import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Modal from "../../Modal/Modal";
/* [POLECENIE WLASCICIELA 2026-09-12] Formularz ZALOZENIA nowego dysku w oknie tworzenia zgloszenia.
   Nazwa techniczna i sciezka sieciowa skladaja sie z reguly (przedrostek KRO_S_FSP_PRO_ -> udzial
   `projects`, KRO_S_FSP_DEP_ -> `departments`) i sa pokazywane NA ZYWO, zanim czlowiek wysle wniosek. */
import FormularzNowegoDysku, {
    PUSTY_NOWY_DYSK, walidujNowyDysk, opisNowegoDyskuHtml,
} from "../../Dyski/FormularzNowegoDysku";
/* [BH-2 2026-09-19] „dodaj opcje zlozenia dysku sieciowego sharepoint”. Witryna SharePoint nie ma
   ani udzialu sieciowego, ani grup AD _RW/_RO, wiec nie miesci sie w formularzu nowego DYSKU —
   ma wlasny, ktory pyta wylacznie o to, co czlowiek spoza IT wie. */
import FormularzNowejWitrynySharePoint, {
    PUSTA_NOWA_WITRYNA, walidujNowaWitryne, opisNowejWitrynyHtml,
} from "../../Dyski/FormularzNowejWitrynySharePoint";
/* [R19/R20 2026-09-13] Wniosek o dostep do dyskow: gesta lista (nazwa kanoniczna, sciezka bez sufiksu RW/RO,
   opis, DZIAL zamiast opiekuna) z przyklejonymi naglowkami grup. */
import ListaDyskowDoWniosku from "../../Dyski/ListaDyskowDoWniosku";
import { opisDyskuDoZgloszeniaHtml } from "../../Dyski/WierszDyskuDoWniosku";
import { nazwaDlaCzlowieka } from "../../Dyski/regulaNazwyDysku";
import { zapamietajDyski, wybraneDyski } from "../../Dyski/wybraneDyskiDoWniosku";
/* [POLECENIE WLASCICIELA 2026-09-12] „optymalizcaje w zakresie wprowadznai danych”.
   Zamkniecie okna kasowalo 42 stany formularza bez ostrzezenia — pracownik wypisujacy pozycje
   zapotrzebowania tracil kilkanascie minut pracy przez jedno klikniecie obok. */
/* [polecenie właściciela 2026-09-20] „zrob tak, ze odswiezene strony nie zamknie tego okna” —
   znacznik otwarcia (z krokiem i wybranym oknem) mieszka w TYM SAMYM module co szkic treści,
   w jednym wpisie pamięci karty. Dwa osobne mechanizmy rozjechałyby się przy pierwszej zmianie. */
import {
    zapiszPrzyZamknieciu, odczytajSzkic, wyczyscSzkic, zapiszSzkic,
    zapamietajOtwarcieOkna, odczytajOtwarcieOkna,
} from "./szkicZgloszenia";
/* [polecenie właściciela 2026-09-20] Reguła układu siatki okien (ile kolumn, jak dopełnić rząd).
   W osobnym module, bo liczba kafelków zmienia się z filtrem i wyszukiwarką przy każdym znaku —
   a regułę da się tam zmierzyć dla 0, 1, 4, 6, 43 kafelków bez montowania okna. */
import { liczbaKolumnSiatki, rozpietosciSekcji } from "./ukladSiatkiOkien";
// SLA obowiązujące kategorii (własne albo z okna) — jedno miejsce reguły dla obu okien zgłoszenia.
import { plakietkiSlaKategorii } from "./slaKategorii";
import { apiService } from "../../../api/apiService";
import { useToast } from "../../../context/ToastContext";
import { useAuth } from "../../../hooks/useAuth";
import { useUI } from "../../../hooks/useUI";
import { localizedPath } from "../../../hooks/useLocalizedNavigate";
import s from "./MyNewTicketModal.module.css";
/* [polecenie właściciela 2026-09-28] Dwie karty okna: „Sprawy techniczne” (całe dotychczasowe okno, bez zmian)
   i „Wnioski pracownicze” (te same wnioski i ten sam kreator co /wnioski-hr). Pytanie przed porzuceniem
   wypełnionego wniosku idzie przez wspólne okno potwierdzeń aplikacji. */
import KartaWnioskowPracowniczych from "./KartaWnioskowPracowniczych";
import { KARTA, odczytajKarte, zapamietajKarte, kartaStartowa } from "./kartyNowegoZgloszenia";
import { useConfirmOpcjonalny } from "../../../context/ConfirmDialogContext";
import DodatkoweOsoby from "./DodatkoweOsoby";
/* [DLA KOGO 2026-09-19] Pole „Dla kogo” w zapotrzebowaniu: wybór konta z aplikacji (dział
   podstawia się sam) ALBO dane wpisane ręcznie. Napisy jadące do zgłoszenia składa wspólny
   moduł, żeby treść sprawy i blok „Dane formularza” nigdy się nie rozjechały. */
import WyborOsobyDlaKogo from "./WyborOsobyDlaKogo";
import {
  PUSTE_DLA_KOGO, daneDlaKogoDoFormularza, opisDzialuDlaKogo, opisOsobyDlaKogo,
} from "./dlaKogoZapotrzebowania";
import {
  FiCpu, FiHardDrive, FiShoppingCart, FiUser, FiPlus,
  FiTrash2, FiArrowLeft, FiCheckCircle, FiEdit, FiSearch,
  FiInfo, FiClock, FiAlertTriangle,
  FiZap, FiSend, FiPackage, FiUploadCloud, FiFile, FiX,
  FiShield, FiServer, FiUserCheck, FiFolder,
  /* [BH 2026-09-19] Zakres wniosku o zasoby: lejek przy nagłówku, chmura przy SharePoint. */
  FiFilter, FiCloud,
  FiMonitor, FiSmartphone, FiPrinter, FiLifeBuoy,
  FiBriefcase, FiUsers, FiTool, FiFileText, FiTruck, FiHome, FiDollarSign, FiInbox, FiRotateCcw,
  FiAward, FiGift, FiLock, FiLogOut, FiUserPlus,} from "react-icons/fi";
import {
  TICKET_TYPE, TICKET_TYPE_LABELS, TICKET_PRIORITY, BACKEND_TICKET_TYPE_MAP,
} from "../../../constants/ticketConstants";
import { renderDynamicFields, buildTicketBody } from "./TicketFormFields";
import categoriesApi from "../../../pages/admin/categoriesApi";
// [R22] Pole kafelka typu „date” na wspólnym DatePickerze aplikacji — wartość zostaje "RRRR-MM-DD".
import { DatePicker } from "../../common/DatePicker";
// [S25 2026-09-14] „Kategoria szczegółowa” — ta sama lista co u obsługi (sekcja okna → kategorie).
import PoleKategorii from "../TicketDetailsModal/PoleKategorii";
/* [polecenie właściciela 2026-09-19] Kroki formularza wykupu — reguła osobno, bo krok „Urządzenie”
   ma dwie postacie (wybór z ewidencji albo wpisany numer) i musi dać się zmierzyć bez montowania okna. */
import { KROKI_WYKUPU, krokWykupu } from "./wykupSprzetu";
import { zbudujDrzewoKategorii } from "../drzewoKategoriiZgloszenia";
import { MAPA_IKON_SPRZETU } from "../../../constants/ikonyTypowSprzetu";
/* [polecenie właściciela 2026-09-19] Wyszukiwarka okien + filtr per moduł + układ sekcyjny siatki.
   Reguła mieszka w osobnym module, żeby dało się ją zmierzyć bez montowania okna. */
import {
    zbudujIndeksOkien, filtrujOknaPoFrazie, pogrupujOknaWSekcje, modulyDoFiltra,
} from "./szukajOkien";
/* [BH 2026-09-19] Reguły wniosku o dostęp do zasobów (spółka, rodzaj, „dla kogo”) — osobny moduł,
   bo kształt `AdditionalData` jest KONTRAKTEM z serwerem i musi dać się zmierzyć bez montowania okna. */
import {
    RODZAJ_ZASOBU, ETYKIETY_RODZAJU, odsiejWybraneSpozaSpolki,
    dodatkoweDaneWnioskuOZasoby, opisZakresuWnioskuHtml, bladZakresuWniosku,
} from "./wniosekOZasoby";

/* ═══════════════════════════════════════════════════════════
   ICON MAP (backend icon name → React component)
   ═══════════════════════════════════════════════════════════ */

/* [2026-09-20] Ikony TYPOW SPRZETU biore z jednego katalogu aplikacji
   (constants/ikonyTypowSprzetu) — lokalna kopia rozjezdzala sie ze slownikiem typow przy
   kazdej nowej ikonie. Ikony kafelkow NIE-sprzetowych (dyski, serwer, katalog) zostaja
   tutaj, bo nie pochodza ze slownika ITAM. */
const ICON_MAP = {
  ...MAPA_IKON_SPRZETU,
  FiHardDrive: FiHardDrive,
  FiServer: FiServer,
  FiFolder: FiFolder,
};

/* ═══════════════════════════════════════════════════════════
   CONSTANTS
   ═══════════════════════════════════════════════════════════ */

const STEP = { SELECT: 0, FORM: 1 };

/* [polecenie właściciela 2026-09-28] „zrob 2 karty - sprawy techniczne, wnioski pracownicze”. Kolejność = kolejność
   na ekranie i w nawigacji strzałkami (WAI-ARIA tabs). */
const KARTY_OKNA = [
  { klucz: KARTA.techniczne, etykieta: "Sprawy techniczne", Ikona: FiTool },
  { klucz: KARTA.wnioski, etykieta: "Wnioski pracownicze", Ikona: FiFileText },
];

/* [poprawka NOWE-ZGLOSZENIE 2026-09-28] ODSYŁACZ „Wnioski HR” z informacji przy oknach kadrowych (polecenie właściciela
   2026-09-20: „daj link”). Bez rozpoczętego wniosku w karcie „Wnioski pracownicze” działa DOKŁADNIE jak dotąd: zamyka okno
   i przechodzi. Z rozpoczętym — najpierw to samo pytanie co ✕, a przejście dopiero po zgodzie; odmowa zostawia okno
   z danymi (pierwsza wersja wołała `zamknij(false)` wprost i wniosek przepadał bez słowa). `useNavigate` żyje w tym małym
   komponencie, bo `Link` i tak wymaga routera, a reszta okna montuje się także bez niego. */
const OdsylaczDoWnioskowHr = ({ zamknij, czyWniosekWypelniony, poPorzuceniuWniosku }) => {
  const navigate = useNavigate();
  const cel = localizedPath("hrRequests");
  const onClick = (e) => {
    if (!czyWniosekWypelniony()) { zamknij(false); return; }
    e.preventDefault();
    poPorzuceniuWniosku(() => { zamknij(false); navigate(cel); });
  };
  return <Link to={cel} onClick={onClick}>Wnioski HR</Link>;
};

const COLOR_MAP = {
  blue: s.cardBlue,
  purple: s.cardPurple,
  orange: s.cardOrange,
  green: s.cardGreen,
  pink: s.cardPink,
  amber: s.cardAmber,
};

const HEADER_ICON_MAP = {
  blue: s.headerIconBlue,
  purple: s.headerIconPurple,
  orange: s.headerIconOrange,
  green: s.headerIconGreen,
  pink: s.headerIconPink,
  amber: s.headerIconAmber,
};

const TYPE_CARDS = [
  {
    type: TICKET_TYPE.TECHNICAL,
    icon: FiCpu,
    title: "Zgłoszenie techniczne",
    desc: "Awarie sprzętu, problemy z oprogramowaniem, reset hasła, usterki sieciowe i inne problemy IT.",
    color: "blue",
  },
  {
    type: TICKET_TYPE.DRIVE_ACCESS,
    icon: FiHardDrive,
    title: "Dostęp do dysków",
    desc: "Wniosek o dostęp do dysków sieciowych — odczyt lub zapis.",
    color: "purple",
  },
  {
    type: TICKET_TYPE.EQUIPMENT_BUYOUT,
    icon: FiShoppingCart,
    title: "Wykup sprzętu",
    desc: "Wniosek o wykup lub wypożyczenie sprzętu firmowego.",
    color: "orange",
  },
  {
    type: TICKET_TYPE.EQUIPMENT_REQUEST,
    icon: FiPackage,
    title: "Zapotrzebowanie IT",
    desc: "Zamówienie nowego sprzętu IT dla pracownika.",
    color: "green",
  },
  {
    type: TICKET_TYPE.PERSONAL_DATA_CHANGE,
    icon: FiUser,
    title: "Dane personalne",
    desc: "Zmiana danych w skrzynce pocztowej (imię, nazwisko, telefon, stanowisko).",
    color: "pink",
  },
  {
    type: TICKET_TYPE.SAP_SUPPORT,
    icon: FiLifeBuoy,
    title: "Wsparcie SAP",
    desc: "Zgłoszenie problemu w systemie SAP — automatycznie przekazywane do działu wsparcia.",
    color: "amber",
  },
];

/* [F2 helpdesk wielodziałowy] Ikony dynamicznych kafelków (Category.TileIcon → komponent).
   Kafelki definiowane w adminie kategorii (IsTile) — obok wbudowanych kafelków IT (D6). */
const TILE_ICONS = {
  FiUsers, FiShoppingCart, FiTool, FiFileText, FiTruck, FiHome, FiDollarSign, FiShield,
  // [G5] ikony kafelków systemowych
  FiCpu, FiHardDrive, FiPackage, FiUser, FiLifeBuoy,
  // [drzewo kategorii IT 2026-09-19] Słownik liczył 13 ikon na 31 okien drzewa IT — nazwa spoza słownika
  // renderuje DOMYŚLNĄ teczkę, więc kilkanaście kafelków wyglądałoby identycznie i nie dałoby się ich
  // rozróżnić wzrokiem. Wszystkie poniższe są już zaimportowane w tym pliku — dokładamy same klucze.
  FiMonitor, FiPrinter, FiSmartphone, FiServer, FiZap, FiAlertTriangle, FiUserCheck, FiFolder,
  FiInbox, FiRotateCcw, FiSearch, FiSend, FiUploadCloud, FiEdit, FiFile, FiInfo,
  /* [drzewo spraw HR 2026-09-19] Te szesc ikon uzywa drzewo HR. Bez nich WSZYSTKIE okna kadrowe
     renderowalyby domyslna teczke — czyli dziewiec kafelkow nie do odroznienia wzrokiem. Wada
     powstala z rownoleglej pracy: drzewo IT i drzewo HR dokladaly ikony do tego samego slownika,
     a katalog HR powstal w osobnym pliku i nikt nie sprawdzal, czy jego nazwy tu istnieja. */
  FiAward, FiGift, FiLock, FiLogOut, FiUserPlus, FiClock,
};
const DEFAULT_TILE_ICON = FiBriefcase;

/* [G5] Kafelki SYSTEMOWE: TileFormKind kategorii -> wbudowany przepływ formularza.
   Render w pełni z danych (nazwa/opis/ikona/kolor/kolejność/aktywność z kategorii). */
const SYSTEM_KIND_TO_TYPE = {
  drives: TICKET_TYPE.DRIVE_ACCESS,
  buyout: TICKET_TYPE.EQUIPMENT_BUYOUT,
  "requisition-it": TICKET_TYPE.EQUIPMENT_REQUEST,
  personal: TICKET_TYPE.PERSONAL_DATA_CHANGE,
  sap: TICKET_TYPE.SAP_SUPPORT,
};
const KIND_COLOR_CLASS = {
  drives: "purple", buyout: "orange", "requisition-it": "green",
  personal: "pink", sap: "amber", generic: "blue", requisition: "blue",
};
const KIND_DEFAULT_ICON = {
  drives: FiHardDrive, buyout: FiShoppingCart, "requisition-it": FiPackage,
  personal: FiUser, sap: FiLifeBuoy,
};

/* ═══════════════════════════════════════════════════════════
   FRAMER MOTION VARIANTS
   ═══════════════════════════════════════════════════════════ */

/* [2026-09-19] Opóźnienie kaskady jest OGRANICZONE. Przy 6 kafelkach `i * 0.06` dawało ładne
   wejście; po rozbudowie katalogu okien jest ich ~40, więc ostatni kafelek pojawiałby się po 2,4 s —
   a przy każdym wpisanym znaku w wyszukiwarce siatka liczy się od nowa. Sufit 8 kroków trzyma
   całą kaskadę poniżej pół sekundy niezależnie od liczby okien. */
const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: Math.min(i, 8) * 0.05, duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] },
  }),
};

const stepVariants = {
  enter: (dir) => ({ x: dir > 0 ? 60 : -60, opacity: 0 }),
  center: { x: 0, opacity: 1, transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] } },
  exit: (dir) => ({ x: dir > 0 ? -60 : 60, opacity: 0, transition: { duration: 0.2 } }),
};

/* ════════════════════════════════════════════════════════════
   COMPONENT
   ════════════════════════════════════════════════════════════ */
const MyNewTicketModal = ({ isOpen, onClose }) => {
  const { user, isModuleRestricted, isModuleGloballyHidden, isModuleContractGated } = useAuth();
  /* `openNewTicketModal` jest tu WYŁĄCZNIE po to, żeby okno mogło wrócić po odświeżeniu strony:
     stan „otwarte" trzyma rodzic (UIContext), a ten komponent jest montowany zawsze — przy
     `isOpen === false` zwraca `null` dopiero po wykonaniu efektów. */
  const { preselectedTicketType, preselectedTicketData, openNewTicketModal } = useUI();
  const { success, error: toastError } = useToast();

  /* ─── loading ─── */
  const [loading, setLoading] = useState(false);

  /* ─── data sources ─── */
  const [categories, setCategories] = useState([]);
  // [MODEL v2] Ograniczenia TWORZENIA per moduł (konfiguracja działowa z access-control):
  // mapa moduleCode -> mayCreate. Moduł spoza mapy = otwarty dla wszystkich (stan domyślny).
  const [createRestrictions, setCreateRestrictions] = useState({});
  // [N3] Diagnostyka pustej siatki: ile okien istnieje i czemu ich nie widać.
  const [tilesDiagnostic, setTilesDiagnostic] = useState(null);
  const [equipmentTypes, setEquipmentTypes] = useState([]);
  /* [polecenie właściciela 2026-09-20] „tak by nie o wszystko dało się wykupić”.
     OSOBNA lista, pobierana z filtrem na SERWERZE (doWykupu=true), a nie odsiana w tym
     pliku z listy ogólnej: odsianie w JS zostawiłoby komplet typów w odpowiedzi, a tabela
     typów podlegających wykupowi jest regułą firmy, nie ustawieniem ekranu. Ta sama lista
     bez filtru zasila „Zapotrzebowanie IT”, gdzie wykup nic nie znaczy. */
  const [typyDoWykupu, setTypyDoWykupu] = useState([]);

  /* ─── navigation ─── */
  const [step, setStep] = useState(STEP.SELECT);
  const [selectedType, setSelectedType] = useState(null);
  // [F2] Dynamiczny kafelek (kategoria z IsTile) — null = przepływ wbudowanych typów.
  const [selectedTileCategory, setSelectedTileCategory] = useState(null);
  const [tileSubject, setTileSubject] = useState("");
  const [tileBody, setTileBody] = useState("");
  const [tileItems, setTileItems] = useState([{ id: 1, name: "", quantity: 1, note: "" }]);
  // [G1] Podkategoria kafelka (dzieci kategorii-kafelka) + wartości pól własnych z konfiguratora.
  const [tileSubcategoryId, setTileSubcategoryId] = useState("");
  const [tileCustomFields, setTileCustomFields] = useState({});
  // [G5] Kategoria-nośnik kafelka SYSTEMOWEGO (drives/buyout/requisition-it/personal/sap).
  const [sourceTileCategory, setSourceTileCategory] = useState(null);
  // [K2] Słownik modułów obsługi — do pokazania userowi „który moduł obsłuży zgłoszenie".
  const [ticketModules, setTicketModules] = useState([]);
  const [direction, setDirection] = useState(1);
  /* [ZGŁOSZENIE WŁAŚCICIELA 2026-09-12] FILTR OKIEŃ PER MODUŁ — „dynamicznie zmieniaj mi listę
     okienek zgłoszenia zależnie czy robię to z karty HR czy IT [...] daj też opcję [...] wyświetlić
     wszystkie, to ma być taki wygodny filtr". Pusty łańcuch = „Wszystkie". Wartość początkową
     podaje ekran, z którego człowiek przyszedł (aktywna zakładka /moje-zgloszenia). */
  const [filtrModulu, setFiltrModulu] = useState("");
  /* [polecenie właściciela 2026-09-19] „zrob wyszukiwarke dla zgloszen”. Po rozbudowie katalogu
     okien jest ich ~40 zamiast 3 — przewijanie siatki przestało być sposobem na znalezienie sprawy. */
  const [frazaSzukania, setFrazaSzukania] = useState("");
  /* Frazy słownika reguł przypisań (`fraza -> kategoria`) wyłącznie do WYSZUKIWANIA. Bez nich
     człowiek wpisujący „nie drukuje” nie dostałby okna „Drukarka / skaner”, bo tych słów nie ma
     ani w nazwie okna, ani w opisie kafelka. Pusta lista (brak reguł, 403, stary backend) jest
     w porządku — wyszukiwarka działa wtedy po nazwach i opisach. */
  const [frazyRegul, setFrazyRegul] = useState([]);

  /* ─── form: shared ─── */
  const [categoryId, setCategoryId] = useState("");
  const [priority, setPriority] = useState(TICKET_PRIORITY.MEDIUM);
  const [files, setFiles] = useState([]);
  /* [OBSZAR D 2026-09-11] Konta DOPISANE do zgloszenia. Trzymamy cale obiekty (id + nazwa + adres),
     a nie same identyfikatory: pigulka musi pokazac czlowieka, a nie liczbe, a drugiego zapytania
     o te same osoby nie ma po co robic. Do serwera i tak jada wylacznie identyfikatory. */
  const [dodatkoweOsoby, setDodatkoweOsoby] = useState([]);
  const [dynamicFields, setDynamicFields] = useState({});
  const [isDragging, setIsDragging] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const fileInputRef = useRef(null);

  /* ─── form: drive access ─── */
  const [drivesGroups, setDrivesGroups] = useState([]);
  // [przegląd R19] Wszystkie zasoby, jakie ta karta widziała w odpowiedziach listy. Wybór przeżywa
  // wyszukiwanie: fraza, która nie obejmuje wybranego dysku, nie zdejmuje go z podsumowania ani z treści
  // zgłoszenia (wniosek i tak by powstał — selectedDrives trzyma id — więc treść rozjeżdżała się z wnioskiem).
  const znaneDyskiRef = useRef(new Map());
  const [loadingDrives, setLoadingDrives] = useState(false);
  const [driveSearch, setDriveSearch] = useState("");
  const [expandedGroups, setExpandedGroups] = useState({});
  const [selectedDrives, setSelectedDrives] = useState([]);
  const [driveAccessLevels, setDriveAccessLevels] = useState({});
  /* Wniosek o ZALOZENIE dysku, ktorego nie ma na liscie. Osobny przelacznik, a nie pozycja na liscie
     dyskow: to inna prosba (utworz zasob) niz „daj mi dostep do istniejacego". */
  /* Pasek „przywrocono rozpoczete zgloszenie”. Pokazujemy go TYLKO wtedy, gdy naprawde bylo co
     przywrocic — samo otwarcie i zamkniecie okna nie ma tresci, a pasek po kliknieciu w nic myli. */
  const [szkicPrzywrocony, setSzkicPrzywrocony] = useState(false);
  const [chceNowyDysk, setChceNowyDysk] = useState(false);
  const [nowyDysk, setNowyDysk] = useState(PUSTY_NOWY_DYSK);
  /* [BH-1/BH-2/BH-3 2026-09-19] Zakres wniosku o zasoby: SPÓŁKA (zawęża listę i jedzie do serwera),
     RODZAJ zasobu (dysk sieciowy / witryna SharePoint) i DLA KOGO (konta z aplikacji, kilka osób).
     Zrzut właściciela pokazuje przy liście licznik „332 zasoby” — przy takiej liczbie zawężenie
     jest warunkiem używalności, a nie ozdobą. */
  const [spolki, setSpolki] = useState([]);
  const [spolkaWniosku, setSpolkaWniosku] = useState("");
  const [rodzajZasobu, setRodzajZasobu] = useState(RODZAJ_ZASOBU.wszystkie);
  const [osobyDostepu, setOsobyDostepu] = useState([]);
  const [nowaWitryna, setNowaWitryna] = useState(PUSTA_NOWA_WITRYNA);
  const searchTimeoutRef = useRef(null);
  const zakresZasobowRef = useRef({ spolka: "", rodzaj: RODZAJ_ZASOBU.wszystkie });


  /* ─── form: buyout ─── */
  const [buyoutData, setBuyoutData] = useState({ hardwareId: "", type: "", reason: "" });
  const [myDevices, setMyDevices] = useState([]);
  const [loadingMyDevices, setLoadingMyDevices] = useState(false);
  const [selectedBuyoutDevice, setSelectedBuyoutDevice] = useState(null);
  const [serialConfirmed, setSerialConfirmed] = useState(false);
  const [serialMismatch, setSerialMismatch] = useState(false);
  const [correctedSerials, setCorrectedSerials] = useState({ serial: "", imei: "" });

  /* ─── form: request items ─── */
  const [requestItems, setRequestItems] = useState([
    { id: Date.now(), type: "", nameOrSerial: "", quantity: 1, ...PUSTE_DLA_KOGO },
  ]);

  /* ─── form: SAP ─── */
  const [sapData, setSapData] = useState({ subject: "", description: "" });

  /* ─── form: personal data ─── */
  const [personalData, setPersonalData] = useState({
    firstName: "", lastName: "", phone: "", email: "", companyPosition: "", reason: "",
  });

  /* ═══════════════════════════════════════════════════════════
     COMPUTED
     ═══════════════════════════════════════════════════════════ */

  const technicalCategories = useMemo(() => {
    /* Categories hidden from the technical ticket dropdown — they have dedicated tiles or are not relevant */
    const HIDDEN_CATEGORY_NAMES = [
      "sap",
      "zapotrzebowanie it",
      "zmiana uprawnień użytkownika",
      "onboarding hr",
      "offboarding",
      "zablokowanie pracownika",
    ];

    const isHiddenCategory = (c) =>
      c.ticketType === BACKEND_TICKET_TYPE_MAP[TICKET_TYPE.SAP_SUPPORT] ||
      (c.name && HIDDEN_CATEGORY_NAMES.some((h) => c.name.toLowerCase().includes(h)));

    // Grupy drzewa kategorii (BRIEF-0003) NIE są wybieralne — odfiltrowane (rendering przez optgroup).
    // [F2] Kategorie-KAFELKI (isTile) mają własny kafelek na kroku wyboru — nie dublujemy ich
    // w drzewie zgłoszenia technicznego.
    // [G0] Moduł IT = kod 'itsm' (słownik TicketModules); 'tickets' czytamy przejściowo (legacy).
    const strict = categories.filter((c) => !c.isGroup && !c.isTile && (c.module === "itsm" || c.module === "tickets") && !c.ticketType && !isHiddenCategory(c));
    if (strict.length > 0) return strict;
    const legacy = categories.filter((c) => !c.isGroup && !c.isTile && !c.module && !c.ticketType && !isHiddenCategory(c));
    if (legacy.length > 0) return legacy;
    return categories.filter((c) => !c.isGroup && !c.isTile && c.module !== "hr" && !c.ticketType && !isHiddenCategory(c));
  }, [categories]);

  /* Drzewo kategorii do <optgroup> (BRIEF-0003): grupy = isGroup, liście po parentCategoryId,
     sieroty (bez rodzica) pod "Inne". Tylko liście wybieralne. */
  /* [S1 2026-09-14] Czwarte miejsce z grupowaniem po `isGroup` przechodzi na wspólną regułę
     (drzewoKategoriiZgloszenia.js). Okna nie wchodzą tu z założenia (`technicalCategories` je odsiewa —
     mają własne kafelki), więc na wejściu są grupy `isGroup` + kategorie techniczne: wynik jest ten sam co
     dotąd, ale następne wywołanie tej gałęzi nie przywróci starej reguły obok nowej. */
  const technicalCategoryTree = useMemo(
    () => zbudujDrzewoKategorii(
      categories.filter((c) => (c.isGroup && !c.isTile) || technicalCategories.includes(c)),
      { tylkoAktywne: false }
    ),
    [categories, technicalCategories]
  );

  // [K2] Pobierz słownik modułów przy otwarciu — do informacji „który moduł obsłuży zgłoszenie".
  useEffect(() => {
    if (!isOpen) return;
    let alive = true;
    apiService.getTicketModules().then((r) => { if (alive) setTicketModules(Array.isArray(r.data) ? r.data : []); }).catch(() => {});
    return () => { alive = false; };
  }, [isOpen]);

  /* [polecenie właściciela 2026-09-19] Frazy słownika reguł do wyszukiwarki okien.
     Wywołanie jest WARUNKOWE (`?.()` + sprawdzenie „thenowalności”), bo ten moduł HTTP bywa
     podmieniany atrapą w testach innych obszarów — brak metody ma dać wyszukiwarkę bez fraz,
     a nie wyjątek kładący całe okno zakładania zgłoszenia. */
  useEffect(() => {
    if (!isOpen) return undefined;
    let alive = true;
    const zadanie = categoriesApi.frazyWyszukiwania?.();
    if (zadanie && typeof zadanie.then === "function") {
      zadanie
        .then((r) => { if (alive) setFrazyRegul(Array.isArray(r?.data) ? r.data : []); })
        .catch(() => { if (alive) setFrazyRegul([]); });
    }
    return () => { alive = false; };
  }, [isOpen]);

  const moduleNameByCode = useMemo(() => {
    const m = {};
    ticketModules.forEach((mod) => { if (mod.code) m[mod.code] = mod.name; });
    return m;
  }, [ticketModules]);

  const matchedCategory = useMemo(() => {
    if (selectedType === null) return null;
    if (selectedType === TICKET_TYPE.TECHNICAL) {
      return categories.find((c) => c.id === categoryId) || null;
    }
    const backendType = BACKEND_TICKET_TYPE_MAP[selectedType];
    return (
      categories.find((c) => (c.module === "itsm" || c.module === "tickets") && c.ticketType === backendType) ||
      categories.find((c) => c.ticketType === backendType) ||
      null
    );
  }, [selectedType, categories, categoryId]);

  /* ─── handling departments per ticket type (for TYPE_CARDS badges) ─── */
  // [F2] Dynamiczne kafelki: kategorie oznaczone w adminie IsTile (bez grup, bez ukrytych).
  const dynamicTiles = useMemo(
    // [G1] Kategorie-nośniki wbudowanych kafelków (ticketType != null) nie dublują się jako dynamiczne.
    // [MODEL v2] Moduł z konfiguracją działową (access-control → „Działy") pokazuje kafelki tworzenia
    // wyłącznie pracownikom działów z włączonym „Tworzeniem"; moduł bez konfiguracji = otwarty.
    () => categories.filter((c) => c.isTile && !c.isGroup && c.ticketType == null
      && (createRestrictions[c.module] === undefined || createRestrictions[c.module] === true)),
    [categories, createRestrictions]
  );

  // [G1] Wbudowane kafelki sterowane danymi: kategoria z pasującym TicketType nadpisuje
  // tytuł/opis, a jej dezaktywacja w konfiguratorze (IsActive=0) CHOWA kafelek.
  // „Zgłoszenie techniczne" i „Dostęp do dysków" (moduł systemowy) są zawsze widoczne.
  const visibleTypeCards = useMemo(() => {
    const hasTypeCats = categories.some((c) => c.ticketType != null);
    return TYPE_CARDS
      .map((card) => {
        const backendType = BACKEND_TICKET_TYPE_MAP[card.type];
        const meta = categories.find((c) => c.ticketType === backendType && !c.isTile);
        return {
          ...card,
          title: meta?.name || card.title,
          desc: meta?.tileDescription || card.desc,
          hidden: hasTypeCats
            && card.type !== TICKET_TYPE.TECHNICAL
            && card.type !== TICKET_TYPE.DRIVE_ACCESS
            && !meta,
        };
      })
      .filter((c) => !c.hidden);
  }, [categories]);

  // [G1] Podkategorie wybranego kafelka (dzieci w drzewie) + definicje pól własnych.
  const tileSubcategories = useMemo(() => {
    if (!selectedTileCategory) return [];
    return categories
      .filter((c) => c.parentCategoryId === selectedTileCategory.id && !c.isGroup && !c.isTile)
      .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0) || a.name.localeCompare(b.name, "pl"));
  }, [categories, selectedTileCategory]);

  const tileFieldDefs = useMemo(
    () => ((selectedTileCategory || sourceTileCategory)?.formFields || []).slice().sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0)),
    [selectedTileCategory, sourceTileCategory]
  );

  // [G5] Pelny data-driven render siatki kafelkow: wszystkie kafelki (systemowe + dzialowe)
  // z kategorii, posortowane po SortOrder. Sciezka legacy (TYPE_CARDS) zostaje fallbackiem,
  // gdy stary backend nie ma jeszcze kafelkow systemowych.
  const dataDrivenTiles = useMemo(
    () => categories
      .filter((c) => c.isTile && !c.isGroup)
      // [AUDYT 2026-07-27] Blokada tworzenia per dział działa TAKŻE tutaj. Wcześniej filtr
      // `createRestrictions` był nałożony wyłącznie na `dynamicTiles` (ścieżka zapasowa), a realnie
      // renderowana jest ta lista — więc pracownik działu bez prawa tworzenia widział kafelek,
      // wypełniał cały formularz i dopiero przy wysyłce dostawał odmowę z serwera.
      .filter((c) => createRestrictions[c.module] === undefined || createRestrictions[c.module] === true)
      .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0) || a.name.localeCompare(b.name, "pl")),
    [categories, createRestrictions]
  );
  // [PRZEBUDOWA 2026-07-27] Siatka jest ZAWSZE data-driven: okna pochodza WYLACZNIE
  // z konfiguratora (/admin/categories). Zadnych kart wbudowanych na sztywno - wlacznie
  // z "Zgloszeniem technicznym" i doklejanym kafelkiem dyskow; wbudowane przeplywy
  // podpina sie oknu przez "widok wbudowany" (tileFormKind) w kreatorze.
  const useDataDrivenGrid = true;

  /* ═════════════════════════════════════════════════════════════════════════
     FILTR OKIEN PER MODUŁ (polecenie właściciela 2026-09-12).
     Zawężenie jest WIDOKOWE, a nie uprawnieniowe: `dataDrivenTiles` jest już przefiltrowane
     bramkami (okno włączone, moduł widoczny, dział ma prawo tworzyć). Ten filtr tylko wybiera
     spośród okien, które człowiek I TAK MOŻE otworzyć — dlatego „Wszystkie" wolno kliknąć
     zawsze i nikomu niczego nie otwiera (A15-06: ukrycie nie jest autoryzacją, a pokazanie
     nie jest nadaniem).
     ═════════════════════════════════════════════════════════════════════════ */
  /* [polecenie właściciela 2026-09-19] „zrob opcje filtrowania zaleznie od instniejacych modulow […]
     dynamicznie”. Lista chipów pochodzi ze SŁOWNIKA MODUŁÓW z bazy (`/api/ticket-modules` — aktywne,
     w kolejności `SortOrder`), przecięta z modułami, które naprawdę mają widoczne okno. Żadnej listy
     modułów w kodzie: właściciel zakłada kolejne moduły i mają się tu pojawić same. */
  const modulyOkienPelne = useMemo(
    () => modulyDoFiltra(dataDrivenTiles, ticketModules),
    [dataDrivenTiles, ticketModules]
  );
  const modulyOkien = useMemo(() => modulyOkienPelne.map((m) => m.kod), [modulyOkienPelne]);

  /* Filtr działa WYŁĄCZNIE wtedy, gdy wskazany moduł naprawdę ma okna. Inaczej wejście
     z zakładki modułu bez własnych okien pokazałoby pustą siatkę — a człowiek przyszedł tu
     po to, żeby coś zgłosić, więc pustka pod pretekstem filtra jest gorsza niż brak filtra. */
  const filtrSkuteczny = filtrModulu && modulyOkien.includes(filtrModulu) ? filtrModulu : "";
  const kafelkiModulu = useMemo(
    () => (filtrSkuteczny ? dataDrivenTiles.filter((c) => c.module === filtrSkuteczny) : dataDrivenTiles),
    [dataDrivenTiles, filtrSkuteczny]
  );

  /* Indeks wyszukiwania liczymy z PEŁNEJ listy kategorii (nie z przefiltrowanej), bo siano okna
     budują też kategorie pod nim i frazy słownika — a te nie są kafelkami. */
  const indeksOkien = useMemo(() => zbudujIndeksOkien(categories, frazyRegul), [categories, frazyRegul]);
  const widoczneKafelki = useMemo(
    () => filtrujOknaPoFrazie(kafelkiModulu, indeksOkien, frazaSzukania),
    [kafelkiModulu, indeksOkien, frazaSzukania]
  );
  /* Grupy (`isGroup`) są NAGŁÓWKAMI sekcji, nie oknami. Przy zerze grup (stan produkcji 19.09)
     wychodzi jedna sekcja bez nagłówka, czyli siatka wygląda dokładnie jak dotąd. */
  const sekcjeKafelkow = useMemo(
    () => pogrupujOknaWSekcje(widoczneKafelki, categories),
    [widoczneKafelki, categories]
  );

  /* ═════════════════════════════════════════════════════════════════════════
     UKŁAD SIATKI (polecenie właściciela 2026-09-20): „zrob mniejsze te miniatury […] ale
     w takiej formie, by dana kategoria dynamicznie wypelniala pole […] jak jest 4, a w rzedzie 5,
     to ostatnia kategorie rozciagnij”.

     Liczba kolumn jest WSPÓLNA (jeden element `grid`, nagłówki sekcji zajmują w nim cały rząd),
     a rozpiętości liczą się PER SEKCJA, bo to nagłówek sekcji łamie rząd — „ostatni rząd” jest
     pojęciem sekcji, nie całej siatki. Cała arytmetyka siedzi w `ukladSiatkiOkien.js`.
     ═════════════════════════════════════════════════════════════════════════ */
  const kolumnySiatki = useMemo(
    () => liczbaKolumnSiatki(widoczneKafelki.length),
    [widoczneKafelki.length]
  );
  /* Mapa `okno -> rozpiętość`. Kluczem jest OBIEKT kategorii (ta sama referencja, co w renderze),
     a nie identyfikator: `id` bywa GUID-em i liczbą, a rozjazd kształtu klucza dałby tu ciche
     `undefined`, czyli rozpiętość 1 i dziurę w rzędzie bez żadnego błędu na ekranie. */
  const rozpietosciKafelkow = useMemo(() => {
    const mapa = new Map();
    sekcjeKafelkow.forEach((sekcja) => {
      const rozpietosci = rozpietosciSekcji(sekcja.okna.length, kolumnySiatki);
      sekcja.okna.forEach((okno, i) => mapa.set(okno, rozpietosci[i] || 1));
    });
    return mapa;
  }, [sekcjeKafelkow, kolumnySiatki]);
  /* Pusty wynik SZUKANIA to co innego niż brak okien w konfiguracji (N3) — i musi się inaczej
     tłumaczyć, bo inne jest wyjście: tam „poproś administratora”, tu „wyczyść frazę”. */
  const pustyWynikSzukania = dataDrivenTiles.length > 0 && widoczneKafelki.length === 0;
  const szukaniemLubFiltrem = !!frazaSzukania.trim() || !!filtrSkuteczny;

  /* Przełącznik pokazujemy dopiero przy DWÓCH modułach — przy jednym byłby kontrolką,
     która nic nie zmienia, czyli śmieciem na ekranie. */
  const pokazFiltrModulow = modulyOkien.length > 1;
  const nazwaModulu = (kod) => moduleNameByCode[kod] || kod;

  const handlingDeptByType = useMemo(() => {
    const map = {};
    TYPE_CARDS.forEach(({ type }) => {
      const backendType = BACKEND_TICKET_TYPE_MAP[type];
      // For TECHNICAL (backendType=1): categories without ticketType (null) in module "tickets"
      // For others: categories with matching ticketType
      let cat;
      if (type === TICKET_TYPE.TECHNICAL) {
        cat = categories.find(c => (c.module === "itsm" || c.module === "tickets") && !c.ticketType && c.handlingDepartment);
      } else {
        cat = categories.find(c => c.ticketType === backendType && c.handlingDepartment);
      }
      if (cat?.handlingDepartment) {
        map[type] = cat.handlingDepartment.name;
      }
    });
    return map;
  }, [categories]);

  /* ─── buyout: devices matching selected equipment type ─── */
  const filteredMyDevices = useMemo(() => {
    if (!buyoutData.type) return [];
    return myDevices.filter((d) => {
      const devTypeName = (d.deviceTypeName || d.deviceType || "").toLowerCase();
      return devTypeName === buyoutData.type.toLowerCase();
    });
  }, [myDevices, buyoutData.type]);

  /* ═══════════════════════════════════════════════════════════
     DYNAMIC FORM VALIDATION
     ═══════════════════════════════════════════════════════════ */

  const MIN_DESC_LENGTH = 20;

  const formErrors = useMemo(() => {
    const errs = {};

    // [F2] Walidacja dynamicznego kafelka (generic: temat+opis; requisition: pozycje).
    if (selectedTileCategory) {
      if (selectedTileCategory.tileFormKind === "requisition") {
        tileItems.forEach((item, idx) => {
          if (!item.name?.trim()) errs[`tileItemName_${idx}`] = "Podaj nazwę pozycji.";
          if (!item.quantity || item.quantity < 1) errs[`tileItemQty_${idx}`] = "Podaj poprawną ilość.";
        });
      } else {
        if (!tileSubject.trim() || tileSubject.trim().length < 5)
          errs.tileSubject = "Temat musi zawierać min. 5 znaków.";
        if (tileBody.trim().length < MIN_DESC_LENGTH)
          errs.tileBody = `Opis musi zawierać min. ${MIN_DESC_LENGTH} znaków (obecnie: ${tileBody.trim().length}).`;
      }
      // [G1] Podkategoria wymagana, gdy kafelek ma zdefiniowane podkategorie.
      if (tileSubcategories.length > 0 && !tileSubcategoryId)
        errs.tileSubcategory = "Wybierz kategorię szczegółową zgłoszenia.";
      // [G1] Pola własne z konfiguratora — wymagane muszą być wypełnione.
      tileFieldDefs.forEach((f) => {
        if (!f.isRequired) return;
        const v = tileCustomFields[f.id];
        if ((f.fieldType === "checkbox" || f.fieldType === "file") ? !v : !String(v ?? "").trim())
          errs[`tileField_${f.id}`] = `Pole „${f.label}" jest wymagane.`;
      });
      return errs;
    }

    if (selectedType === null) return errs;

    switch (selectedType) {
      case TICKET_TYPE.TECHNICAL: {
        if (!categoryId) errs.categoryId = "Wybierz kategorię problemu.";
        const catObj = categories.find((c) => c.id === categoryId);
        const catType = catObj ? Number(catObj.type) : null;
        if (categoryId) {
          if (catType === 3 && !dynamicFields.passwordType)
            errs.passwordType = "Wybierz typ hasła.";
          if (catType === 4 && !dynamicFields.printerNumber?.trim())
            errs.printerNumber = "Podaj numer drukarki.";
          if (catType === 6 && !dynamicFields.phoneProblem)
            errs.phoneProblem = "Wybierz typ problemu.";
          if (catType === 4 || catType === 6 || catType === 1 || catType === 2 || catType === 5 || catType === null || catType === 0) {
            const desc = dynamicFields.description || "";
            if (catType !== 3 && desc.trim().length < MIN_DESC_LENGTH)
              errs.description = `Opis musi zawierać min. ${MIN_DESC_LENGTH} znaków (obecnie: ${desc.trim().length}).`;
          }
          if (catType === 3) {
            /* additionalInfo is optional for password type */
          }
        }
        break;
      }
      case TICKET_TYPE.DRIVE_ACCESS: {
        if (chceNowyDysk) {
          /* Wniosek o nowy zasob zastepuje wybor z listy — walidujemy formularz, nie liste.
             [BH-2] KTÓRY formularz, rozstrzyga rodzaj zasobu: witryna SharePoint nie ma ani udzialu
             sieciowego, ani grup AD, wiec walidacja nazwy dysku odrzucalaby poprawny wniosek o witryne. */
          const bledyNowego = rodzajZasobu === RODZAJ_ZASOBU.sharepoint
            ? walidujNowaWitryne(nowaWitryna)
            : walidujNowyDysk(nowyDysk);
          if (Object.keys(bledyNowego).length) errs.drives = Object.values(bledyNowego)[0];
        } else if (selectedDrives.length === 0) {
          errs.drives = rodzajZasobu === RODZAJ_ZASOBU.sharepoint
            ? "Wybierz przynajmniej jedną witrynę albo zaznacz, że potrzebujesz nowej."
            : "Wybierz przynajmniej jeden dysk albo zaznacz, że potrzebujesz nowego dysku.";
        }
        // [BH-3] Sufity liczby zasobów i osób — te same liczby, co na serwerze. Mówimy o nich TU,
        // bo odmowa po wysłaniu każe człowiekowi zgadywać, co dokładnie przekroczył.
        const bladZakresu = bladZakresuWniosku({ wybrane: selectedDrives, osoby: osobyDostepu });
        if (bladZakresu) errs.osobyDostepu = bladZakresu;
        break;
      }
      case TICKET_TYPE.EQUIPMENT_BUYOUT:
        if (!buyoutData.type) errs.buyoutType = "Wybierz typ sprzętu.";
        if (buyoutData.type) {
          if (filteredMyDevices.length > 0) {
            if (!selectedBuyoutDevice) errs.buyoutDevice = "Wybierz urządzenie z listy.";
            if (selectedBuyoutDevice && !serialConfirmed && !serialMismatch)
              errs.buyoutSerial = "Potwierdź numery seryjne lub zgłoś niezgodność.";
            if (selectedBuyoutDevice && serialMismatch && !correctedSerials.serial?.trim())
              errs.buyoutCorrectedSerial = "Podaj aktualny numer seryjny.";
          } else {
            if (!buyoutData.hardwareId?.trim())
              errs.buyoutHardwareId = "Podaj numer seryjny urządzenia.";
          }
          const reason = buyoutData.reason || "";
          if (reason.trim().length < MIN_DESC_LENGTH)
            errs.buyoutReason = `Powód wykupu musi zawierać min. ${MIN_DESC_LENGTH} znaków (obecnie: ${reason.trim().length}).`;
        }
        break;
      case TICKET_TYPE.EQUIPMENT_REQUEST:
        requestItems.forEach((item, idx) => {
          if (!item.type) errs[`reqType_${idx}`] = "Wybierz typ sprzętu.";
          if (!item.nameOrSerial?.trim()) errs[`reqName_${idx}`] = "Podaj nazwę lub link do przedmiotu.";
          // Powód i CZYNNOŚĆ — od 19.09 są dwie drogi, więc komunikat musi wymienić obie.
          if (!item.forWhom?.trim())
            errs[`reqFor_${idx}`] = "Wskaż, dla kogo jest sprzęt — wybierz pracownika z aplikacji albo wpisz imię i nazwisko.";
          if (!item.quantity || item.quantity < 1) errs[`reqQty_${idx}`] = "Podaj poprawną ilość.";
        });
        break;
      case TICKET_TYPE.PERSONAL_DATA_CHANGE:
        if (!personalData.firstName?.trim()) errs.pdFirstName = "Podaj imię.";
        if (!personalData.lastName?.trim()) errs.pdLastName = "Podaj nazwisko.";
        if (!personalData.email?.trim()) errs.pdEmail = "Podaj adres email.";
        if (personalData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(personalData.email))
          errs.pdEmail = "Podaj poprawny adres email.";
        if (!personalData.phone?.trim()) errs.pdPhone = "Podaj numer telefonu.";
        if ((personalData.reason || "").trim().length < MIN_DESC_LENGTH)
          errs.pdReason = `Powód zmiany musi zawierać min. ${MIN_DESC_LENGTH} znaków (obecnie: ${(personalData.reason || "").trim().length}).`;
        break;
      case TICKET_TYPE.SAP_SUPPORT:
        if (!sapData.subject?.trim()) errs.sapSubject = "Podaj temat zgłoszenia.";
        if (sapData.subject?.trim() && sapData.subject.trim().length < 5)
          errs.sapSubject = "Temat musi zawierać min. 5 znaków.";
        if ((sapData.description || "").trim().length < MIN_DESC_LENGTH)
          errs.sapDescription = `Opis musi zawierać min. ${MIN_DESC_LENGTH} znaków (obecnie: ${(sapData.description || "").trim().length}).`;
        break;
      default: break;
    }
    // [G5] Pola własne kategorii-nośnika kafelka SYSTEMOWEGO — wymagane muszą być wypełnione.
    if (sourceTileCategory) {
      tileFieldDefs.forEach((f) => {
        if (!f.isRequired) return;
        const v = tileCustomFields[f.id];
        if ((f.fieldType === "checkbox" || f.fieldType === "file") ? !v : !String(v ?? "").trim())
          errs[`tileField_${f.id}`] = `Pole „${f.label}" jest wymagane.`;
      });
    }
    return errs;
  }, [
    selectedType, categoryId, categories, dynamicFields,
    // `chceNowyDysk` i `nowyDysk` MUSZA tu byc: bez nich komunikat bledu nie przeliczalby sie przy
    // edycji formularza nowego dysku — czlowiek poprawialby pole i nadal widzial stary blad.
    // [BH 2026-09-19] Z tego samego powodu musza tu byc `rodzajZasobu`, `nowaWitryna` i `osobyDostepu`:
    // przelaczenie rodzaju zmienia, KTORY formularz jest walidowany, a bez tego komunikat zostalby stary.
    selectedDrives, chceNowyDysk, nowyDysk, rodzajZasobu, nowaWitryna, osobyDostepu,
    buyoutData, filteredMyDevices, selectedBuyoutDevice,
    serialConfirmed, serialMismatch, correctedSerials,
    requestItems, personalData, sapData,
    selectedTileCategory, tileSubject, tileBody, tileItems,
    tileSubcategories, tileSubcategoryId, tileFieldDefs, tileCustomFields, sourceTileCategory,
  ]);

  const isFormValid = useMemo(() => Object.keys(formErrors).length === 0, [formErrors]);

  /* helper: render field error */
  const fieldError = (key) =>
    showErrors && formErrors[key]
      ? <span className={s.fieldError}>{formErrors[key]}</span>
      : null;

  /* ═══════════════════════════════════════════════════════════
     RESET
     ═══════════════════════════════════════════════════════════ */

  /** Migawka pol, ktore warto uratowac. Musi zgadzac sie z `POLA_SZKICU`. */
  const zlozSzkic = useCallback(() => ({
    step, selectedType, selectedTileCategory, tileSubject, tileBody, tileItems,
    tileSubcategoryId, tileCustomFields, sourceTileCategory,
    categoryId, priority, dynamicFields, dodatkoweOsoby,
    selectedDrives, driveAccessLevels, chceNowyDysk, nowyDysk,
    // [BH 2026-09-19] Zakres wniosku o zasoby też jest pracą do uratowania: spółka i lista osób
    // to kilkanaście kliknięć, a bez nich przywrócony szkic wysłałby wniosek o co innego.
    spolkaWniosku, rodzajZasobu, osobyDostepu, nowaWitryna,
    buyoutData, selectedBuyoutDevice, serialConfirmed, correctedSerials,
    sapData, requestItems, personalData,
  }), [step, selectedType, selectedTileCategory, tileSubject, tileBody, tileItems,
      tileSubcategoryId, tileCustomFields, sourceTileCategory, categoryId, priority,
      dynamicFields, dodatkoweOsoby, selectedDrives, driveAccessLevels, chceNowyDysk, nowyDysk,
      spolkaWniosku, rodzajZasobu, osobyDostepu, nowaWitryna,
      buyoutData, selectedBuyoutDevice, serialConfirmed, correctedSerials, sapData,
      requestItems, personalData]);

  /** Przywraca szkic. ⚠ Zalacznikow NIE da sie odtworzyc — pasek mowi o tym wprost. */
  const przywrocSzkic = useCallback((szkic) => {
    if (!szkic) return;
    if ("step" in szkic) setStep(szkic.step);
    if ("selectedType" in szkic) setSelectedType(szkic.selectedType);
    if ("selectedTileCategory" in szkic) setSelectedTileCategory(szkic.selectedTileCategory);
    if ("tileSubject" in szkic) setTileSubject(szkic.tileSubject);
    if ("tileBody" in szkic) setTileBody(szkic.tileBody);
    if ("tileItems" in szkic) setTileItems(szkic.tileItems);
    if ("tileSubcategoryId" in szkic) setTileSubcategoryId(szkic.tileSubcategoryId);
    if ("tileCustomFields" in szkic) setTileCustomFields(szkic.tileCustomFields);
    if ("sourceTileCategory" in szkic) setSourceTileCategory(szkic.sourceTileCategory);
    if ("categoryId" in szkic) setCategoryId(szkic.categoryId);
    if ("priority" in szkic) setPriority(szkic.priority);
    if ("dynamicFields" in szkic) setDynamicFields(szkic.dynamicFields);
    if ("dodatkoweOsoby" in szkic) setDodatkoweOsoby(szkic.dodatkoweOsoby);
    if ("selectedDrives" in szkic) setSelectedDrives(szkic.selectedDrives);
    if ("driveAccessLevels" in szkic) setDriveAccessLevels(szkic.driveAccessLevels);
    if ("chceNowyDysk" in szkic) setChceNowyDysk(szkic.chceNowyDysk);
    if ("nowyDysk" in szkic) setNowyDysk(szkic.nowyDysk);
    if ("spolkaWniosku" in szkic) setSpolkaWniosku(szkic.spolkaWniosku);
    if ("rodzajZasobu" in szkic) setRodzajZasobu(szkic.rodzajZasobu);
    // Referencja zawężenia idzie razem ze stanem — patrz `fetchDrives`.
    zakresZasobowRef.current = {
      spolka: szkic.spolkaWniosku ?? "",
      rodzaj: szkic.rodzajZasobu ?? RODZAJ_ZASOBU.wszystkie,
    };
    if ("osobyDostepu" in szkic) setOsobyDostepu(szkic.osobyDostepu);
    if ("nowaWitryna" in szkic) setNowaWitryna(szkic.nowaWitryna);
    if ("buyoutData" in szkic) setBuyoutData(szkic.buyoutData);
    if ("selectedBuyoutDevice" in szkic) setSelectedBuyoutDevice(szkic.selectedBuyoutDevice);
    if ("serialConfirmed" in szkic) setSerialConfirmed(szkic.serialConfirmed);
    if ("correctedSerials" in szkic) setCorrectedSerials(szkic.correctedSerials);
    if ("sapData" in szkic) setSapData(szkic.sapData);
    if ("requestItems" in szkic) setRequestItems(szkic.requestItems);
    if ("personalData" in szkic) setPersonalData(szkic.personalData);
    setSzkicPrzywrocony(true);
  }, []);

  /**
   * Zamkniecie okna. Przy ZWYKLYM zamknieciu (✕ / Anuluj) zapisujemy szkic, zeby praca nie zniknela;
   * po UDANYM wyslaniu szkic jest juz wyczyszczony i nie ma czego zapisywac.
   * ⚠ Zapis idzie PRZED `onClose`, bo rodzic odmontowuje okno i stany przestaja istniec.
   */
  const zamknij = useCallback((wyslano = false) => {
    // Cala decyzja (czy i co zapisac) siedzi w module — tam jest zmierzona zachowaniem.
    zapiszPrzyZamknieciu(user?.id, wyslano, zlozSzkic());
    onClose(wyslano);
  }, [onClose, user, zlozSzkic]);

  const resetForm = useCallback(() => {
    setStep(STEP.SELECT);
    setSelectedType(null);
    setSelectedTileCategory(null);
    setTileSubject("");
    setTileBody("");
    setTileItems([{ id: 1, name: "", quantity: 1, note: "" }]);
    setDirection(1);
    setCategoryId("");
    setPriority(TICKET_PRIORITY.MEDIUM);
    setFiles([]);
    setDynamicFields({});
    setIsDragging(false);
    setShowErrors(false);
    setSelectedDrives([]);
    setDriveAccessLevels({});
    setChceNowyDysk(false);
    setNowyDysk(PUSTY_NOWY_DYSK);
    // [BH 2026-09-19] Zakres wniosku o zasoby. Bez tego wybór spółki z POPRZEDNIEGO otwarcia
    // zawężałby po cichu listę komuś, kto przyszedł po zasób zupełnie innej firmy.
    setSpolkaWniosku("");
    setRodzajZasobu(RODZAJ_ZASOBU.wszystkie);
    setOsobyDostepu([]);
    setNowaWitryna(PUSTA_NOWA_WITRYNA);
    // Referencja zawężenia musi iść RAZEM ze stanem — inaczej pierwsze pobranie listy po otwarciu
    // okna użyłoby spółki z poprzedniej sprawy i pracownik dostałby pustą listę bez wyjaśnienia.
    zakresZasobowRef.current = { spolka: "", rodzaj: RODZAJ_ZASOBU.wszystkie };
    setBuyoutData({ hardwareId: "", type: "", reason: "" });
    setMyDevices([]);
    setSelectedBuyoutDevice(null);
    setSerialConfirmed(false);
    setSerialMismatch(false);
    setCorrectedSerials({ serial: "", imei: "" });
    setSapData({ subject: "", description: "" });
    setRequestItems([{ id: Date.now(), type: "", nameOrSerial: "", quantity: 1, ...PUSTE_DLA_KOGO }]);
    setPersonalData({ firstName: "", lastName: "", phone: "", email: "", companyPosition: "", reason: "" });
    setDriveSearch("");
    setDrivesGroups([]);
    // [F19] Stany G1/G5 nośnika kafelka — bez tego kategoria-nośnik (np. SAP z ForwardToEmail)
    // przeżywała zamknięcie modala i doklejała się do KOLEJNEGO zgłoszenia (śmieciowy ticket z auto-forwardem).
    setSourceTileCategory(null);
    setTileCustomFields({});
    setTileSubcategoryId("");
    setSzkicPrzywrocony(false);
  }, []);

  /* ═══════════════════════════════════════════════════════════
     DATA FETCHING
     ═══════════════════════════════════════════════════════════ */

  const fetchCategories = useCallback(async () => {
    try {
      const res = await apiService.getCategories();
      const data = Array.isArray(res.data) ? res.data : [];
      if (data.length === 0) console.warn("[NewTicketModal] No categories returned from API");
      setCategories(data);
    } catch (err) {
      console.error("[NewTicketModal] fetchCategories error:", err);
    }
    // [MODEL v2] Ograniczenia tworzenia per moduł (best-effort: błąd = brak ograniczeń).
    try {
      const restr = await apiService.getMyCreateRestrictions();
      const map = {};
      (restr.data?.restrictedModules || []).forEach(r => { map[r.moduleCode] = r.mayCreate; });
      setCreateRestrictions(map);
    } catch { setCreateRestrictions({}); }

    // [N3 2026-08-31] DLACZEGO siatka jest pusta. Dotąd jeden komunikat („Brak skonfigurowanych
    // okien zgłoszeń") opisywał TRZY różne sytuacje: brak okien, okno wyłączone / w wyłączonym
    // module oraz okno modułu ograniczonego do wybranych działów. Właściciel dodawał okna
    // w konfiguratorze, widział tu pustkę i nie miał czego szukać.
    try {
      const diag = await categoriesApi.widocznoscOkien();
      setTilesDiagnostic(diag.data || null);
    } catch { setTilesDiagnostic(null); }
  }, []);

  // [AUDYT 2026-07-27] Typy sprzętu bierzemy z endpointu PORTALU (/my-tickets/equipment-types),
  // a nie z /itam/device-types: kontroler ITAM stoi za polityką obsługi majątku, więc zwykłemu
  // pracownikowi zwracał 403 — lista zostawała pusta, wymagane pole nie do wypełnienia,
  // a kafelków „Wykup sprzętu" i „Zapotrzebowanie IT" nie dało się wysłać.
  const fetchEquipmentTypes = useCallback(async () => {
    try {
      const res = await apiService.getEquipmentTypesForTicket();
      const data = Array.isArray(res.data) ? res.data : [];
      if (data.length === 0) console.warn("[NewTicketModal] No equipment types returned from API");
      setEquipmentTypes(data);
    } catch (err) {
      console.error("[NewTicketModal] fetchEquipmentTypes error:", err);
      setEquipmentTypes([]);
    }
  }, []);

  const fetchTypyDoWykupu = useCallback(async () => {
    try {
      const res = await apiService.getEquipmentTypesForTicket(true);
      setTypyDoWykupu(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      /* Pusta lista jest tu ODPOWIEDZIĄ („nic nie podlega wykupowi”), a nie awarią —
         odbicie się do listy ogólnej podstawiłoby typy, których reguła zabrania. */
      console.error("[NewTicketModal] fetchTypyDoWykupu error:", err);
      setTypyDoWykupu([]);
    }
  }, []);

  const fetchMyDevices = useCallback(async () => {
    setLoadingMyDevices(true);
    try {
      const res = await apiService.getMyAssignedDevices();
      setMyDevices(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("[NewTicketModal] fetchMyDevices error:", err);
      setMyDevices([]);
    } finally {
      setLoadingMyDevices(false);
    }
  }, []);

  /* [BH-1/BH-2 2026-09-19] Lista zasobów jest zawężana PRZEZ SERWER — spółką i rodzajem zasobu.
     🔴 Zawężenie w przeglądarce („pobierz wszystko i odfiltruj") byłoby pozorne: endpoint oddaje
     zasoby grupami po lokalizacji i już dziś jest ich kilkaset, więc filtr po stronie karty
     znaczyłby tyle, że każdy pracownik pobiera cały katalog zasobów firmy przy każdej zmianie
     wyboru. Parametry jadą więc do `/my-tickets/all-drives-grouped`.

     🔴 ZAWĘŻENIE SIEDZI W REFERENCJI, NIE W ARGUMENCIE WYWOŁANIA. Listę pobiera też efekt wejścia
     w formularz, wołany bezargumentowo — a jego zależności obejmują cały obiekt konta, więc
     odpala się ponownie przy każdym odświeżeniu kontekstu logowania. Gdyby zawężenie żyło wyłącznie
     w argumencie, KAŻDY taki przebieg po cichu przywracał pełną listę kilkuset zasobów i kasował
     wybór spółki zrobiony sekundę wcześniej. Referencja jest ustawiana PRZED pobraniem (stan
     Reacta jest asynchroniczny i w tym samym przebiegu miałby jeszcze starą wartość). */
  const fetchDrives = useCallback(async (search = "") => {
    const { spolka, rodzaj } = zakresZasobowRef.current;
    setLoadingDrives(true);
    try {
      const res = await apiService.getAllDrivesGrouped(search, spolka, rodzaj);
      zapamietajDyski(znaneDyskiRef.current, res.data || []);
      setDrivesGroups(res.data || []);
      if (search.length > 0) {
        const allExpanded = {};
        (res.data || []).forEach((g) => {
          if (g.drives.length > 0) allExpanded[g.masterDiskAddress] = true;
        });
        setExpandedGroups(allExpanded);
      }
    } catch (err) {
      console.error(err);
      toastError("Błąd pobierania listy dysków.");
    } finally {
      setLoadingDrives(false);
    }
  }, [toastError]);

  /* [BH-1 2026-09-19] SŁOWNIK SPÓŁEK — „firma z definicji do wyboru”, a nie wolne pole tekstowe.
     Brak odpowiedzi (starszy serwer, brak uprawnienia do słownika) NIE MOŻE wywracać formularza:
     pusta lista znaczy tyle, że pole wyboru się nie pojawia i wniosek idzie bez zawężenia —
     dokładnie tak, jak działał do tej fali. */
  const fetchSpolki = useCallback(async () => {
    try {
      const res = await apiService.getCompanies();
      setSpolki(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("[NewTicketModal] fetchSpolki error:", err);
      setSpolki([]);
    }
  }, []);

  /* ═══════════════════════════════════════════════════════════
     EFFECTS
     ═══════════════════════════════════════════════════════════ */

  /* [ZGŁOSZENIE WŁAŚCICIELA 2026-09-12] „wczytuje się puste okno modal [...] zamiast okienek".
     Rodzaj wstępnego wyboru JEST LICZBĄ (TICKET_TYPE). Wcześniej warunek brzmiał „skoro nie jest
     null ani undefined, to jest rodzajem" — i przepuszczał WSZYSTKO, w tym obiekt zdarzenia
     kliknięcia, który React wstawia w pierwszy argument procedury obsługi podanej wprost.
     Okno przeskakiwało wtedy na krok formularza dla rodzaju spoza słownika, `renderFormBody()`
     zwracało `null` i człowiek dostawał PUSTE okno z samym „Wróć".
     Wywołujący ekran też został poprawiony, ale ta bramka ma stać NIEZALEŻNIE: okno otwiera się
     z pulpitu, z paska bocznego, z szybkiego dostępu i z portalu — jeden przeoczony `onClick`
     w dowolnym z nich wracałby dokładnie tym samym objawem. */
  const wstepnyRodzaj = typeof preselectedTicketType === "number" ? preselectedTicketType : null;

  /* 🔴 [2026-09-13] ZALEZNOSCI EFEKTU OTWARCIA TO WYLACZNIE WARTOSCI PROSTE.
     G6 dopisal tu `user` (caly obiekt konta), zeby odczytac szkic. Kazda nowa referencja tego obiektu
     uruchamiala efekt od nowa, a efekt zaczyna od `resetForm()`:
       - w tescie mock `useAuth` oddaje nowy obiekt przy kazdym renderze -> reset -> render -> reset...
         („Maximum update depth exceeded”, suita wisiala bez konca);
       - na produkcji odswiezenie konta przy OTWARTYM oknie (token, zmiana uprawnien) czyscilo formularz
         w trakcie pisania — dokladnie to, przed czym szkic mial chronic.
     Dlatego efekt zalezy od identyfikatora konta i od PROSTYCH pol tresci wstepnej, a nie od obiektow. */
  const idKonta = user?.id ?? null;
  /* [2026-09-20] „To otwarcie jest POWROTEM po odświeżeniu, a nie kliknięciem człowieka”.
     Ustawia ją efekt odtworzenia (niżej), czyta efekt otwarcia okna i od razu zeruje. Bez tego
     rozróżnienia zwykłe kliknięcie „Utwórz nowe zgłoszenie” wrzucałoby człowieka w formularz
     okna, które kiedyś otworzył i porzucił bez wpisania ani jednej litery. */
  const odtworzenieWToku = useRef(false);
  const maTrescWstepna = !!preselectedTicketData;
  const modulWstepny = typeof preselectedTicketData?.modulZgloszenia === "string" ? preselectedTicketData.modulZgloszenia : "";
  const tematWstepny = preselectedTicketData?.temat || "";
  const opisWstepny = preselectedTicketData?.opis || "";

  useEffect(() => {
    if (isOpen) {
      resetForm();
      fetchCategories();
      fetchEquipmentTypes();
      // Filtr modułu z ekranu wywołującego. Ustawiamy ZAWSZE (także na pusty), żeby wybór
      // z poprzedniego otwarcia nie zawężał po cichu następnego.
      setFiltrModulu(modulWstepny);
      // Z tego samego powodu co filtr: fraza z poprzedniego otwarcia ukrywałaby po cichu
      // większość okien komuś, kto przyszedł po zupełnie inną sprawę.
      setFrazaSzukania("");
      if (wstepnyRodzaj !== null) {
        setSelectedType(wstepnyRodzaj);
        setStep(STEP.FORM);
      }

      // [G-1] Wstepnie wypelniony temat i opis (np. „zglos poprawke" przy sprzecie na pulpicie).
      // Kategorie uzytkownik wybiera SAM — to ona rozstrzyga routing zgloszenia, wiec podstawiamy
      // wylacznie tresc, ktora i tak musialby przepisac z naklejki na sprzecie.
      if (tematWstepny) setTileSubject(tematWstepny);
      if (opisWstepny) setTileBody(opisWstepny);

      /* SZKIC przywracamy na KONIEC — po resecie i po wstepnym wyborze, zeby nie zostal nadpisany.
         ⚠ Nie przywracamy go, gdy ekran wywolujacy podal wlasna tresc (`preselectedTicketData`):
         czlowiek kliknal „zglos poprawke" przy KONKRETNYM sprzecie i spodziewa sie TEGO zgloszenia,
         a nie swojego starego szkicu o czym innym. */
      if (!maTrescWstepna) {
        const szkic = odczytajSzkic(idKonta);
        if (szkic) {
          przywrocSzkic(szkic);
        } else if (odtworzenieWToku.current) {
          /* [polecenie właściciela 2026-09-20] „…nie zamknie tego okna” — i NA KTÓRYM KROKU.
             Okno otwarte bez wpisanej ani jednej litery NIE MA szkicu (`szkicMaTresc` mówi, że
             samo wejście w kafelek to jeszcze nie praca), a mimo to ma wrócić tam, gdzie stało.
             Dlatego sam KROK i wybrane okno jadą przy znaczniku otwarcia, osobno od treści.

             ⚠ WYŁĄCZNIE NA ŚCIEŻCE ODTWORZENIA (`odtworzenieWToku`), nigdy przy zwykłym kliknięciu
             „Utwórz nowe zgłoszenie”. Kto świadomie klika ten przycisk, zaczyna NOWĄ sprawę —
             wrzucenie go od razu w formularz okna, w którym kiedyś nic nie wpisał, byłoby
             odebraniem mu wyboru. Przy szkicu z TREŚCIĄ jest odwrotnie i tak zostaje: tam jest
             co ratować, więc okno wraca na swój krok razem z paskiem „przywrócono” (reguła z 12.09).
             ⚠ Bez paska „przywrócono”: nie było czego przywracać, a pasek po kliknięciu w nic
             tylko myli (ta sama zasada, co przy pustym szkicu od 12.09). */
          const nawigacja = odczytajOtwarcieOkna(idKonta);
          if (nawigacja && nawigacja.step != null) {
            setStep(nawigacja.step);
            setSelectedType(nawigacja.selectedType ?? null);
            setSelectedTileCategory(nawigacja.selectedTileCategory ?? null);
            setSourceTileCategory(nawigacja.sourceTileCategory ?? null);
          }
        }
      }
      odtworzenieWToku.current = false;
    }
  }, [isOpen, wstepnyRodzaj, maTrescWstepna, modulWstepny, tematWstepny, opisWstepny, idKonta,
      resetForm, fetchCategories, fetchEquipmentTypes, przywrocSzkic]);

  /* ═════════════════════════════════════════════════════════════════════════
     KARTY OKNA (polecenie właściciela 2026-09-28)
     „w oknie Utworz nowe zgloszenie - zrob 2 karty - sprawy techniczne, wnioski pracownicze; jak techniczne
     wczytuj to co jest teraz, jak wnioski pracownicze, to co mozna zlozyc w sekcji mpracownik.krosno.com/wnioski-hr”.

     Karta techniczna = CAŁE dotychczasowe okno 1:1 (te same stany, efekty i wysyłka — ten plik niżej). Karta wniosków
     montuje się przy pierwszym wejściu i ZOSTAJE zamontowana do zamknięcia okna, więc przełączenie kart nie kasuje
     wpisanego wniosku (stan techniczny i tak mieszka w tym komponencie).
     Widoczność modułu „Wnioski HR” (ten sam predykat, co trasa /wnioski-hr) gasi kartę — to warstwa UI, nie
     autoryzacja (A15-06): o tym, co wolno złożyć, decyduje serwer (`GET /hr-requests/available-types`).
     ═════════════════════════════════════════════════════════════════════════ */
  const wnioskiDostepne = !(
    (typeof isModuleGloballyHidden === "function" && isModuleGloballyHidden("hrRequests"))
    || (typeof isModuleRestricted === "function" && isModuleRestricted("hrRequests"))
    || (typeof isModuleContractGated === "function" && isModuleContractGated("hrRequests"))
  );
  /* Efekt karty startowej czyta widoczność przez referencję: odświeżenie kontekstu logowania przy OTWARTYM oknie
     nie może przerzucać człowieka między kartami (lekcja efektu otwarcia z 2026-09-13). */
  const wnioskiDostepneRef = useRef(wnioskiDostepne);
  wnioskiDostepneRef.current = wnioskiDostepne;
  const [karta, setKarta] = useState(KARTA.techniczne);
  const [kartaWnioskowZamontowana, setKartaWnioskowZamontowana] = useState(false);
  const kartaAktywna = wnioskiDostepne ? karta : KARTA.techniczne;
  const idKart = React.useId();
  const przyciskiKartRef = useRef({});

  /* Wniosek z wpisanymi danymi — pytamy przed porzuceniem (✕, Anuluj, Escape). Referencja, nie stan: pytanie ma
     widzieć stan z chwili kliknięcia. Karta techniczna ma własną ochronę (szkic zgłoszenia) i o nic nie pyta — bez zmian. */
  const wniosekWypelnionyRef = useRef(false);
  const potwierdzanieWToku = useRef(false);
  const potwierdz = useConfirmOpcjonalny();
  const potwierdzPorzucenieWniosku = useCallback(() => {
    const opcje = {
      title: "Porzucić wniosek?",
      message: "Wypełniony wniosek nie został wysłany. Jeśli go porzucisz, wpisane dane zostaną utracone.",
      confirmText: "Porzuć wniosek",
      cancelText: "Wróć do wniosku",
      danger: true,
      // Fokus startowy na „Wróć do wniosku” — odruchowy Enter nie może skasować wpisanych danych.
      fokusNaAnulowaniu: true,
    };
    if (typeof potwierdz === "function") return potwierdz(opcje);
    /* Bez wspólnego okna potwierdzeń (inne otoczenie montażu) nie ma kogo zapytać — a brak okna NIE znaczy zgody
       (reguła `useConfirmOpcjonalny`). Natywnego `window.confirm` w aplikacji nie ma (A16-16). */
    return Promise.resolve(false);
  }, [potwierdz]);

  /** Akcja, która porzuca wypełniony wniosek (zamknięcie okna, wyjście odsyłaczem): bez wpisów — od razu, z wpisami —
      dopiero po zgodzie w pytaniu. Jedna droga dla ✕ / Anuluj / Escape i odsyłacza „Wnioski HR”. */
  const poPorzuceniuWniosku = useCallback((akcja) => {
    if (!wniosekWypelnionyRef.current) { akcja(); return; }
    if (potwierdzanieWToku.current) return;   // drugi klik przy otwartym pytaniu nie otwiera drugiego
    potwierdzanieWToku.current = true;
    Promise.resolve(potwierdzPorzucenieWniosku()).then((tak) => {
      potwierdzanieWToku.current = false;
      if (!tak) return;
      wniosekWypelnionyRef.current = false;
      akcja();
    }, () => { potwierdzanieWToku.current = false; });
  }, [potwierdzPorzucenieWniosku]);

  /** Zamknięcie okna (✕ / Anuluj / Escape). Bez wypełnionego wniosku — dokładnie dotychczasowe `zamknij(false)`. */
  const zamknijOkno = useCallback(() => poPorzuceniuWniosku(() => zamknij(false)), [poPorzuceniuWniosku, zamknij]);
  const czyWniosekWypelniony = useCallback(() => wniosekWypelnionyRef.current, []);

  const ustawWypelnienieWniosku = useCallback((tak) => { wniosekWypelnionyRef.current = !!tak; }, []);

  const wybierzKarte = useCallback((nowa) => {
    setKarta(nowa);
    if (nowa === KARTA.wnioski) setKartaWnioskowZamontowana(true);
    zapamietajKarte(idKonta, nowa);
  }, [idKonta]);
  const doSprawTechnicznych = useCallback(() => wybierzKarte(KARTA.techniczne), [wybierzKarte]);

  /* Strzałki / Home / End przełączają karty (aktywacja automatyczna) i przenoszą fokus — WAI-ARIA tabs. */
  const klawiszKart = (e) => {
    const i = KARTY_OKNA.findIndex((x) => x.klucz === kartaAktywna);
    let j = null;
    if (e.key === "ArrowRight") j = (i + 1) % KARTY_OKNA.length;
    else if (e.key === "ArrowLeft") j = (i - 1 + KARTY_OKNA.length) % KARTY_OKNA.length;
    else if (e.key === "Home") j = 0;
    else if (e.key === "End") j = KARTY_OKNA.length - 1;
    if (j === null) return;
    e.preventDefault();
    const nowa = KARTY_OKNA[j].klucz;
    wybierzKarte(nowa);
    przyciskiKartRef.current[nowa]?.focus();
  };

  /* KARTA STARTOWA przy każdym otwarciu: ostatnio wybrana (pamięć per konto), ale sprawa techniczna wskazana przez
     ekran wywołujący (rodzaj/treść) albo przywrócony szkic zgłoszenia zawsze otwiera kartę techniczną.
     Efekt stoi PO efekcie otwarcia, więc widzi już przywrócony szkic. */
  useEffect(() => {
    if (!isOpen) return;
    wniosekWypelnionyRef.current = false;
    potwierdzanieWToku.current = false;
    const start = kartaStartowa({
      wnioskiDostepne: wnioskiDostepneRef.current,
      sprawaTechnicznaWskazana: wstepnyRodzaj !== null || maTrescWstepna || !!odczytajSzkic(idKonta),
      zapamietana: odczytajKarte(idKonta),
    });
    setKarta(start);
    setKartaWnioskowZamontowana(start === KARTA.wnioski);
  }, [isOpen, wstepnyRodzaj, maTrescWstepna, idKonta]);

  /* ═════════════════════════════════════════════════════════════════════════
     PRZETRWANIE ODŚWIEŻENIA STRONY (polecenie właściciela 2026-09-20)
     „Utworz nowe zgloszenie — zrob tak, ze odswiezene strony nie zamknie tego okna.”
     ═════════════════════════════════════════════════════════════════════════ */

  /* 1. ZNACZNIK OTWARCIA jest aktualizowany CIĄGLE, a nie raz przy otwarciu. F5 nie zapowiada się
        niczym pewnym (`beforeunload` nie wykona się przy awarii karty), więc pamięć karty ma być
        prawdziwa w każdej chwili, a nie dopiero w chwili, którą uda się złapać. */
  useEffect(() => {
    if (!isOpen || idKonta == null) return;
    zapamietajOtwarcieOkna(idKonta, { step, selectedType, selectedTileCategory, sourceTileCategory });
  }, [isOpen, idKonta, step, selectedType, selectedTileCategory, sourceTileCategory]);

  /* 2. TREŚĆ zapisujemy przy wyjściu ze strony. Zapisywanie 42 stanów przy każdym naciśniętym
        klawiszu byłoby serializacją całego formularza na literę; `beforeunload`/`pagehide` łapie
        odświeżenie, zamknięcie karty i przejście pod inny adres. Gdyby nie złapało (twarda awaria),
        wraca samo okno — bez treści, co i tak jest lepsze niż dzisiejsze „okno znika”.
        ⚠ Migawka idzie przez REFERENCJĘ do najświeższej wersji `zlozSzkic`, bo procedura obsługi
        zdarzenia zapamiętałaby domknięcie sprzed ostatniego wpisanego znaku. */
  const zlozSzkicRef = useRef(zlozSzkic);
  zlozSzkicRef.current = zlozSzkic;
  useEffect(() => {
    if (!isOpen || idKonta == null) return undefined;
    const przedWyjsciem = () => { zapiszSzkic(idKonta, zlozSzkicRef.current()); };
    window.addEventListener("beforeunload", przedWyjsciem);
    window.addEventListener("pagehide", przedWyjsciem);
    return () => {
      window.removeEventListener("beforeunload", przedWyjsciem);
      window.removeEventListener("pagehide", przedWyjsciem);
    };
  }, [isOpen, idKonta]);

  /* 3. ODTWORZENIE — JEDNA PRÓBA NA WCZYTANIE STRONY, i ani jednej więcej.
        ⚠ `probaOdtworzenia` zapala się przy PIERWSZYM przebiegu tego efektu, także wtedy, gdy okno
        jest już otwarte. To jest cała reguła: okno wraca WYŁĄCZNIE dlatego, że strona właśnie się
        wczytała — nigdy dlatego, że w trakcie pracy zamknął je ktoś inny niż ✕ / Anuluj.
        Świadome zamknięcie kasuje znacznik (`zapiszPrzyZamknieciu`), więc tamta droga jest zamknięta
        dwa razy; ale zamknięcie Z ZEWNĄTRZ — rodzic woła `closeNewTicketModal`, bo to publiczna
        metoda kontekstu — znacznika NIE kasuje, i bez tej bramki okno otwierałoby się z powrotem
        pod palcami człowieka, który właśnie je zamknął.
        ⚠ Na wspólnym stanowisku decyduje TOŻSAMOŚĆ: `odczytajOtwarcieOkna` oddaje wpis wyłącznie
        temu kontu, które go zapisało (porównanie w `szkicZgloszenia.js`), więc po przelogowaniu
        nikt nie dostanie okna poprzednika. */
  const probaOdtworzenia = useRef(false);
  useEffect(() => {
    if (probaOdtworzenia.current || idKonta == null) return;
    probaOdtworzenia.current = true;
    if (isOpen) return;
    if (!odczytajOtwarcieOkna(idKonta)) return;
    // Znacznik dla efektu otwarcia: to okno wraca po odświeżeniu, a nie jest otwierane ręcznie.
    odtworzenieWToku.current = true;
    if (typeof openNewTicketModal === "function") openNewTicketModal();
  }, [isOpen, idKonta, openNewTicketModal]);

  /* 4. JEDEN PASEK PRZEWIJANIA. Siatka okien przewija się teraz wewnątrz modalu; gdyby strona pod
        spodem przewijała się razem z nim, kółko myszy nad krawędzią kafelka ruszałoby raz jednym,
        raz drugim. Poprzednia wartość jest przywracana, a nie zerowana — nad tym oknem bywa inne
        (podgląd zgłoszenia), które też mogło blokować przewijanie. */
  useEffect(() => {
    if (!isOpen) return undefined;
    const poprzednia = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = poprzednia; };
  }, [isOpen]);

  /* 🔴 [BH 2026-09-19] ZALEŻNOŚCI TEGO EFEKTU TO WYŁĄCZNIE WARTOŚCI PROSTE — dokładnie z tego
     samego powodu, co przy efekcie otwarcia okna (poprawka 2026-09-13). Efekt zależał od CAŁEGO
     obiektu konta, a ten dostaje nową tożsamość przy każdym odświeżeniu kontekstu logowania.
     SKUTEK: każde takie odświeżenie POBIERAŁO OD NOWA całą listę zasobów (na produkcji kilkaset
     wierszy) i cały sprzęt pracownika — w trakcie wypełniania formularza, bez żadnego śladu.
     W teście, gdzie atrapa konta oddaje nowy obiekt przy każdym renderze, jest to pętla bez końca
     i lista zasobów nigdy nie przestaje się ładować. */
  const imieKonta = user?.firstName || "";
  const nazwiskoKonta = user?.lastName || "";
  const mailKonta = user?.email || "";
  const telefonKonta = user?.phoneNumber || "";

  useEffect(() => {
    if (!isOpen || step !== STEP.FORM || selectedType === null) return;

    if (idKonta !== null && selectedType === TICKET_TYPE.PERSONAL_DATA_CHANGE) {
      setPersonalData({
        firstName: imieKonta, lastName: nazwiskoKonta,
        email: mailKonta, phone: telefonKonta,
        companyPosition: "", reason: "",
      });
    }
    if (selectedType === TICKET_TYPE.DRIVE_ACCESS) { fetchDrives(); fetchSpolki(); }
    if (selectedType === TICKET_TYPE.EQUIPMENT_BUYOUT) { fetchMyDevices(); fetchTypyDoWykupu(); }

    if (selectedType !== TICKET_TYPE.TECHNICAL) {
      // [F4] Kliknięty kafelek SYSTEMOWY niesie własną kategorię (sourceTileCategory) — np. admin
      // stworzył 'Wsparcie Enova' (kind='sap', własny ForwardToEmail, dział=Księgowość). Bez tego
      // efekt dobierał WBUDOWANY nośnik po ticketType → zły desk i przekazanie na sap-krosno.
      if (sourceTileCategory) {
        setCategoryId(sourceTileCategory.id);
      } else {
        const backendType = BACKEND_TICKET_TYPE_MAP[selectedType];
        const match =
          categories.find((c) => (c.module === "itsm" || c.module === "tickets") && c.ticketType === backendType) ||
          categories.find((c) => c.ticketType === backendType);
        if (match) setCategoryId(match.id);
      }
    }
  }, [selectedType, step, isOpen, categories, fetchDrives, fetchMyDevices, fetchTypyDoWykupu, fetchSpolki, sourceTileCategory,
      idKonta, imieKonta, nazwiskoKonta, mailKonta, telefonKonta]);

  /* ═══════════════════════════════════════════════════════════
     HANDLERS
     ═══════════════════════════════════════════════════════════ */

  const selectType = (type, cat = null) => {
    setDirection(1);
    setSelectedType(type);
    setSelectedTileCategory(null);
    // [G5] Kategoria-nośnik kafelka systemowego: pola własne, przekazanie, CategoryId.
    setSourceTileCategory(cat);
    setTileCustomFields({});
    setStep(STEP.FORM);
  };

  // [F2] Wejście w dynamiczny kafelek (kategoria IsTile z admina).
  const selectTile = (cat) => {
    setDirection(1);
    setSelectedType(null);
    setSelectedTileCategory(cat);
    setTileSubject("");
    setTileBody("");
    setTileItems([{ id: 1, name: "", quantity: 1, note: "" }]);
    setTileSubcategoryId("");
    setTileCustomFields({});
    setStep(STEP.FORM);
  };

  const goBack = () => {
    setDirection(-1);
    setSelectedType(null);
    setSelectedTileCategory(null);
    setSourceTileCategory(null);
    setStep(STEP.SELECT);
    setCategoryId("");
    setDynamicFields({});
    setFiles([]);
  };

  const handleCategoryChange = (e) => { setCategoryId(e.target.value); setDynamicFields({}); };
  const handleDynamicFieldChange = (e) => {
    const { name, value } = e.target;
    setDynamicFields((prev) => ({ ...prev, [name]: value }));
  };

  /* ─── Drag & Drop ─── */
  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setFiles((prev) => [...prev, ...newFiles]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleDragOver = (e) => { e.preventDefault(); e.stopPropagation(); setIsDragging(true); };
  const handleDragLeave = (e) => { e.preventDefault(); e.stopPropagation(); setIsDragging(false); };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prev) => [...prev, ...droppedFiles]);
  };
  const removeFile = (idx) => setFiles((prev) => prev.filter((_, i) => i !== idx));

  /* ─── Drive handlers ─── */
  const handleDriveSearchChange = (e) => {
    const val = e.target.value;
    setDriveSearch(val);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => fetchDrives(val), 400);
  };

  /* [BH-1 2026-09-19] ZMIANA SPÓŁKI PRZELICZA LISTĘ **I ZAZNACZENIA**.
     🔴 Samo przeładowanie listy byłoby zawężeniem pozornym: `selectedDrives` trzyma identyfikatory,
     więc dysk zaznaczony przed zmianą spółki pojechałby do serwera mimo że zniknął z ekranu —
     a serwer odrzuca taki wniosek kodem `zasob_innej_spolki`. Człowiek dostałby odmowę mówiącą
     o zasobie, którego już nie widzi. Regułę odsiewania trzyma `wniosekOZasoby`. */
  const handleSpolkaChange = (e) => {
    const wartosc = e.target.value;
    setSpolkaWniosku(wartosc);
    zakresZasobowRef.current = { ...zakresZasobowRef.current, spolka: wartosc };
    setSelectedDrives((poprzednie) => {
      const zostaja = odsiejWybraneSpozaSpolki(znaneDyskiRef.current, poprzednie, wartosc);
      if (zostaja.length !== poprzednie.length) {
        // Odebranie wyboru bez słowa jest nie do zdiagnozowania (lekcja z 16.09) — mówimy wprost.
        toastError(`Zdjęto z wniosku ${poprzednie.length - zostaja.length} zasób/zasoby innej spółki.`);
        setDriveAccessLevels((p) => {
          const n = {};
          zostaja.forEach((id) => { if (id in p) n[id] = p[id]; });
          return n;
        });
      }
      return zostaja;
    });
    fetchDrives(driveSearch);
  };

  /* [BH-2 2026-09-19] Rodzaj zasobu (dysk sieciowy / witryna SharePoint) zawęża listę tak samo jak
     spółka. Zaznaczeń NIE odsiewamy: zasób innego rodzaju jest nadal zasobem TEJ firmy i serwer
     przyjmuje wniosek o niego — odebranie wyboru byłoby tu szkodą, nie ochroną. */
  const handleRodzajZasobuChange = (rodzaj) => {
    setRodzajZasobu(rodzaj);
    zakresZasobowRef.current = { ...zakresZasobowRef.current, rodzaj };
    fetchDrives(driveSearch);
  };

  const toggleGroup = (key) => setExpandedGroups((p) => ({ ...p, [key]: !p[key] }));

  const handleDriveSelection = (id, checked) => {
    if (checked) {
      setSelectedDrives((p) => [...p, id]);
      setDriveAccessLevels((p) => ({ ...p, [id]: "read" }));
    } else {
      setSelectedDrives((p) => p.filter((x) => x !== id));
      setDriveAccessLevels((p) => { const n = { ...p }; delete n[id]; return n; });
    }
  };

  const handleDriveAccessLevelChange = (id, level) => {
    setDriveAccessLevels((p) => ({ ...p, [id]: level }));
  };

  /* ─── Buyout device handlers ─── */
  const handleSelectBuyoutDevice = (device) => {
    if (selectedBuyoutDevice?.id === device.id) {
      setSelectedBuyoutDevice(null);
      setSerialConfirmed(false);
      setSerialMismatch(false);
      setCorrectedSerials({ serial: "", imei: "" });
    } else {
      setSelectedBuyoutDevice(device);
      setSerialConfirmed(false);
      setSerialMismatch(false);
      setCorrectedSerials({ serial: "", imei: "" });
    }
  };

  const handleBuyoutTypeChange = (typeName) => {
    setBuyoutData((p) => ({ ...p, type: typeName }));
    setSelectedBuyoutDevice(null);
    setSerialConfirmed(false);
    setSerialMismatch(false);
    setCorrectedSerials({ serial: "", imei: "" });
  };

  const toggleSerialConfirm = () => {
    if (!serialConfirmed) {
      setSerialMismatch(false);
      setCorrectedSerials({ serial: "", imei: "" });
    }
    setSerialConfirmed((p) => !p);
  };

  const toggleSerialMismatch = () => {
    if (!serialMismatch) {
      setSerialConfirmed(false);
    }
    setSerialMismatch((p) => !p);
  };

  /* ─── Request item handlers ─── */
  const addRequestItem = () => {
    setRequestItems((p) => [...p, { id: Date.now(), type: "", nameOrSerial: "", quantity: 1, ...PUSTE_DLA_KOGO }]);
  };
  const removeRequestItem = (id) => {
    if (requestItems.length > 1) setRequestItems((p) => p.filter((i) => i.id !== id));
  };
  const updateRequestItem = (id, field, value) => {
    setRequestItems((p) => p.map((i) => (i.id === id ? { ...i, [field]: value } : i)));
  };
  /* [DLA KOGO 2026-09-19] Kilka pól pozycji JEDNYM ruchem. Wybór konta ustawia naraz nazwę,
     powiązanie z kontem, dział i źródło działu — te cztery dane opisują jedną decyzję człowieka
     i muszą wejść razem, żeby nie było renderu z nowym nazwiskiem i cudzym działem. */
  const updateRequestItemPatch = (id, patch) => {
    setRequestItems((p) => p.map((i) => (i.id === id ? { ...i, ...patch } : i)));
  };

  /* ═══════════════════════════════════════════════════════════
     PAYLOAD & SUBMIT
     ═══════════════════════════════════════════════════════════ */

  const preparePayload = () => {
    let finalSubject = "";
    let finalDescription = "";
    let finalCategoryId = categoryId;

    // [F2] Dynamiczny kafelek: kategoria = kafelek (routing do jej działu realizującego po stronie
    // backendu); Type=1 (zwykłe zgłoszenie — bez specjalnych przepływów IT).
    if (selectedTileCategory) {
      const fd = new FormData();

      // [G1] Pola własne z konfiguratora → blok definicji w treści zgłoszenia.
      const esc = (v) => String(v ?? "").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      let customBlock = "";
      if (tileFieldDefs.length > 0) {
        const rows = tileFieldDefs.map((f) => {
          const raw = tileCustomFields[f.id];
          const val = f.fieldType === "checkbox" ? (raw ? "Tak" : "Nie")
            : f.fieldType === "file" ? (raw ? `📎 ${esc(raw.name)} (w załącznikach)` : "—")
            : esc(raw ?? "");
          return `<p><strong>${esc(f.label)}:</strong> ${val || "—"}</p>`;
        }).join("");
        customBlock = `<h4>Dane formularza</h4>${rows}`;
      }

      if (selectedTileCategory.tileFormKind === "requisition") {
        const rows = tileItems
          .filter((it) => it.name?.trim())
          .map((it, i) => `<tr><td>${i + 1}</td><td>${esc(it.name)}</td><td>${it.quantity}</td><td>${esc(it.note) || "—"}</td></tr>`)
          .join("");
        fd.append("Subject", `Zapotrzebowanie — ${selectedTileCategory.name}`);
        fd.append("Body",
          `<h3>Zapotrzebowanie — ${selectedTileCategory.name}</h3>` +
          `<table border="1" cellpadding="6" cellspacing="0" style="border-collapse:collapse">` +
          `<thead><tr><th>#</th><th>Pozycja</th><th>Ilość</th><th>Uwagi</th></tr></thead>` +
          `<tbody>${rows}</tbody></table>` + customBlock);
      } else {
        fd.append("Subject", tileSubject.trim());
        fd.append("Body", `<h3>${tileSubject.trim()}</h3><p>${(tileBody || "").replace(/\n/g, "<br/>")}</p>${customBlock}`);
      }
      // [G1] Podkategoria (jeśli wybrana) — precyzyjniejsza klasyfikacja; routing dziedziczy
      // dział realizujący z kafelka po stronie backendu (MailboxResolver).
      fd.append("CategoryId", tileSubcategoryId || selectedTileCategory.id);
      fd.append("Priority", priority);
      fd.append("Type", 1);
      // [K3] Strukturalne wartości pól własnych (obok treści HTML) — do filtrowania/raportów/edycji.
      const fdj = buildFieldDataJson();
      if (fdj) fd.append("FormDataJson", fdj);
      // [OBSZAR D 2026-09-11] Osoby dopisane do sprawy. Serwer odsiewa autora, konta wygaszone
    // i konta bez adresu — tutaj nie powielamy tych regul, bo regula w przegladarce jest sugestia.
    dodatkoweOsoby.forEach((o) => fd.append("UczestnicyUserIds", o.id));

    files.forEach((f) => fd.append("Attachments", f));
      // [K1b] Pliki z pól-załączników formularza kafelka → do załączników zgłoszenia.
      tileFieldDefs.filter((f) => f.fieldType === "file").forEach((f) => {
        const file = tileCustomFields[f.id];
        if (file) fd.append("Attachments", file);
      });
      return fd;
    }

    if (selectedType === TICKET_TYPE.TECHNICAL) {
      const catObj = categories.find((c) => c.id === categoryId);
      const categoryType = catObj ? catObj.type : null;
      finalSubject = catObj ? catObj.name : TICKET_TYPE_LABELS[TICKET_TYPE.TECHNICAL];
      finalDescription = buildTicketBody(categoryType, dynamicFields) || "";
    } else {
      finalSubject = TICKET_TYPE_LABELS[selectedType];
      // [G0] Brak dopasowanej kategorii typu = zgłoszenie BEZ kategorii (routing spadnie na
      // domyślną skrzynkę itsm). Wcześniejszy fallback „pierwszy liść drzewa" przypinał
      // LOSOWĄ kategorię, czyli potencjalnie losowy desk.

      let details = "";
      switch (selectedType) {
        case TICKET_TYPE.DRIVE_ACCESS: {
          // [przegląd R19] Z pamięci karty, nie z bieżącego wyniku wyszukiwania — patrz wybraneDyskiDoWniosku.
          const list = wybraneDyski(znaneDyskiRef.current, selectedDrives, drivesGroups)
            // [R19/R20] Nazwa kanoniczna, sciezka bez sufiksu, grupa AD (dla IT), dzial i opis — ta sama
            // tresc, ktora pracownik widzial w wierszu; BEZ opiekuna (akceptujacego serwer bierze z ewidencji).
            .map((d) => opisDyskuDoZgloszeniaHtml(d, driveAccessLevels[d.id]))
            .join("");
          /* [BH 2026-09-19] Naglowek wniosku: SPOLKA, RODZAJ zasobu i DLA KOGO. Te trzy rzeczy musza
             stac w TRESCI sprawy, a nie tylko w tabeli wnioskow — obsluga i gospodarz zasobu czytaja
             watek, a zgloszenie o dostep dla trzech osob bez ani jednego nazwiska jest nie do obslugi. */
          const nazwaSpolki = (spolki.find((sp) => String(sp.id) === String(spolkaWniosku)) || {}).name || "";
          details = `<h3>Wniosek o dostęp do zasobów</h3>`
            + opisZakresuWnioskuHtml({ nazwaSpolki, rodzaj: rodzajZasobu, osoby: osobyDostepu })
            + `<ul>${list || "<li>Nie wybrano zasobów</li>"}</ul>`;
          // Opis nowego zasobu (nazwa techniczna, udzial, sciezka, uzasadnienie — albo dane witryny)
          // dokladany jest do TRESCI zgloszenia: obsluga widzi komplet w jednym miejscu.
          if (chceNowyDysk) {
            details += rodzajZasobu === RODZAJ_ZASOBU.sharepoint
              ? opisNowejWitrynyHtml(nowaWitryna)
              : opisNowegoDyskuHtml(nowyDysk);
          }
          break;
        }
        case TICKET_TYPE.EQUIPMENT_BUYOUT: {
          details = `<h3>Wniosek o wykup sprzętu</h3>`;
          details += `<p><strong>Typ sprzętu:</strong> ${buyoutData.type}</p>`;

          if (selectedBuyoutDevice) {
            details += `<p><strong>Urządzenie z ewidencji ITAM:</strong> ${selectedBuyoutDevice.deviceName || selectedBuyoutDevice.deviceModel || "—"}</p>`;
            details += `<p><strong>Producent / Model:</strong> ${[selectedBuyoutDevice.deviceManufacturer, selectedBuyoutDevice.deviceModel].filter(Boolean).join(" ") || "—"}</p>`;
            details += `<p><strong>Nr seryjny (ewidencja):</strong> ${selectedBuyoutDevice.deviceSerialNumber || "—"}</p>`;
            if (selectedBuyoutDevice.deviceImei) {
              details += `<p><strong>IMEI (ewidencja):</strong> ${selectedBuyoutDevice.deviceImei}</p>`;
            }
            if (selectedBuyoutDevice.inventoryNumber) {
              details += `<p><strong>Nr inwentarzowy:</strong> ${selectedBuyoutDevice.inventoryNumber}</p>`;
            }

            if (serialConfirmed) {
              details += `<p>✅ <strong>Numery seryjne potwierdzone przez pracownika.</strong></p>`;
            } else if (serialMismatch) {
              details += `<p>⚠️ <strong>NIEZGODNOŚĆ NUMERÓW SERYJNYCH — WYMAGA ANALIZY</strong></p>`;
              details += `<p><strong>Aktualny S/N (wg pracownika):</strong> ${correctedSerials.serial || "—"}</p>`;
              if (correctedSerials.imei) {
                details += `<p><strong>Aktualny IMEI (wg pracownika):</strong> ${correctedSerials.imei}</p>`;
              }
            }
          } else {
            details += `<p><strong>Nr seryjny / identyfikacyjny:</strong> ${buyoutData.hardwareId || "—"}</p>`;
            if (buyoutData.inventoryNumber) {
              details += `<p><strong>Nr inwentarzowy:</strong> ${buyoutData.inventoryNumber}</p>`;
            }
            details += `<p><em>Sprzęt wprowadzony ręcznie — brak w ewidencji ITAM dla tego pracownika.</em></p>`;
          }

          details += `<p><strong>Powód wykupu:</strong> ${buyoutData.reason}</p>`;
          break;
        }
        case TICKET_TYPE.EQUIPMENT_REQUEST: {
          details = `<h3>Zapotrzebowanie na sprzęt IT</h3><ul>`;
          requestItems.forEach((item, i) => {
            // [DLA KOGO 2026-09-19] „Dla” i „Dział” składa wspólny moduł — DOKŁADNIE ten sam
            // napis, co w bloku „Dane formularza”. Dwa osobne sklejenia rozjechałyby się przy
            // pierwszej poprawce i obsługa widziałaby w wątku co innego niż w danych sprawy.
            details += `<li><strong>Poz. ${i + 1}:</strong> ${item.type}, Ilość: ${item.quantity}, Opis: ${item.nameOrSerial}`
              + `, Dla: ${opisOsobyDlaKogo(item)}, Dział: ${opisDzialuDlaKogo(item)}</li>`;
          });
          details += `</ul>`;
          break;
        }
        case TICKET_TYPE.PERSONAL_DATA_CHANGE:
          details = `<h3>Zmiana danych personalnych</h3><p><strong>Imię:</strong> ${personalData.firstName}</p><p><strong>Nazwisko:</strong> ${personalData.lastName}</p><p><strong>Email:</strong> ${personalData.email}</p><p><strong>Telefon:</strong> ${personalData.phone}</p><p><strong>Stanowisko:</strong> ${personalData.companyPosition}</p><p><strong>Powód:</strong> ${personalData.reason}</p>`;
          break;
        case TICKET_TYPE.SAP_SUPPORT: {
          // [G1] Stopka „Dane zgłaszającego" dokładana WYŁĄCZNIE przez backend (z książki adresowej)
          // przy wysyłce przekazania — frontowa wersja dublowała się w mailu do SAP.
          finalSubject = sapData.subject || "Zgłoszenie SAP";
          details = sapData.description;
          break;
        }
        default: break;
      }
      finalDescription = details;
    }

    // [G5] Pola własne kategorii-nośnika kafelka systemowego → blok w treści zgłoszenia.
    if (sourceTileCategory && tileFieldDefs.length > 0) {
      const esc = (v) => String(v ?? "").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      const rows = tileFieldDefs.map((f) => {
        const raw = tileCustomFields[f.id];
        const val = f.fieldType === "checkbox" ? (raw ? "Tak" : "Nie")
          : f.fieldType === "file" ? (raw ? `📎 ${esc(raw.name)} (w załącznikach)` : "—")
          : esc(raw ?? "");
        return `<p><strong>${esc(f.label)}:</strong> ${val || "—"}</p>`;
      }).join("");
      finalDescription += `<h4>Dane formularza</h4>${rows}`;
    }
    // [G5] Kategoria-nośnik = CategoryId zgłoszenia (routing na desk + przekazanie z konfiguracji).
    if (!finalCategoryId && sourceTileCategory) finalCategoryId = sourceTileCategory.id;

    const fd = new FormData();
    fd.append("Subject", finalSubject);
    fd.append("Body", finalDescription);
    if (finalCategoryId) fd.append("CategoryId", finalCategoryId);
    fd.append("Priority", priority);
    fd.append("Type", BACKEND_TICKET_TYPE_MAP[selectedType] || 1);
    // [K3] Strukturalne wartości pól własnych kafelka systemowego.
    // [DLA KOGO 2026-09-19] …plus „dla kogo / dział” z pozycji zapotrzebowania. To JEDYNY kanał,
    // którym ta dana dojeżdża do BAZY maszynowo: `AdditionalData` serwer rozbiera wyłącznie dla
    // wniosku o dostęp do zasobów (typ 2) i NIGDZIE go nie zapisuje, a `Ticket.FormDataJson` ma
    // własną kolumnę i renderuje się w karcie zgłoszenia jako blok „Dane formularza”.
    const daneFormularza = {
      ...(sourceTileCategory ? buildFieldDataObject() : {}),
      ...(selectedType === TICKET_TYPE.EQUIPMENT_REQUEST ? daneDlaKogoDoFormularza(requestItems) : {}),
    };
    if (Object.keys(daneFormularza).length > 0) fd.append("FormDataJson", JSON.stringify(daneFormularza));

    if (selectedType === TICKET_TYPE.DRIVE_ACCESS) {
      /* [BH 2026-09-19] KSZTAŁT OBIEKTOWY: `{CompanyId, DlaUserIds, Drives}`.
         Serwer (`ParserWnioskuODostep`) rozumie oba kształty — gołą tablicę pozycji sprzed tej fali
         i ten obiekt — właśnie dlatego, że front i API wdrażają się osobno. Reguła składania siedzi
         w `wniosekOZasoby`, żeby dało się ją zmierzyć bez montowania okna. */
      fd.append("AdditionalData", JSON.stringify(dodatkoweDaneWnioskuOZasoby({
        spolka: spolkaWniosku,
        wybrane: selectedDrives,
        poziomy: driveAccessLevels,
        osoby: osobyDostepu,
      })));
    }

    if (selectedType === TICKET_TYPE.EQUIPMENT_BUYOUT) {
      const buyoutPayload = {
        equipmentType: buyoutData.type,
        reason: buyoutData.reason,
      };

      if (selectedBuyoutDevice) {
        buyoutPayload.itamDeviceId = selectedBuyoutDevice.id;
        buyoutPayload.deviceName = selectedBuyoutDevice.deviceName;
        buyoutPayload.serialNumberFromItam = selectedBuyoutDevice.deviceSerialNumber;
        buyoutPayload.imeiFromItam = selectedBuyoutDevice.deviceImei;
        buyoutPayload.inventoryNumber = selectedBuyoutDevice.inventoryNumber;
        buyoutPayload.serialConfirmed = serialConfirmed;
        buyoutPayload.serialMismatch = serialMismatch;

        if (serialMismatch) {
          buyoutPayload.correctedSerialNumber = correctedSerials.serial;
          buyoutPayload.correctedImei = correctedSerials.imei;
        }
      } else {
        buyoutPayload.manualEntry = true;
        buyoutPayload.manualSerialNumber = buyoutData.hardwareId;
        buyoutPayload.manualInventoryNumber = buyoutData.inventoryNumber || "";
      }

      fd.append("AdditionalData", JSON.stringify(buyoutPayload));
    }

    files.forEach((f) => fd.append("Attachments", f));
    // [K1b] Pliki z pól-załączników kafelka systemowego → do załączników zgłoszenia.
    if (sourceTileCategory) {
      tileFieldDefs.filter((f) => f.fieldType === "file").forEach((f) => {
        const file = tileCustomFields[f.id];
        if (file) fd.append("Attachments", file);
      });
    }
    return fd;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedType === null && !selectedTileCategory) { toastError("Wybierz typ zgłoszenia."); return; }
    setShowErrors(true);
    if (!isFormValid) {
      const firstErr = Object.values(formErrors)[0];
      toastError(firstErr || "Formularz zawiera błędy. Popraw zaznaczone pola.");
      return;
    }
    setLoading(true);
    try {
      await apiService.createUserTicket(preparePayload());
      /* [poprawka NOWE-ZGLOSZENIE 2026-09-28] Rozpoczęty wniosek w drugiej karcie nie może przepaść razem z zamknięciem
         okna po wysłaniu zgłoszenia: okno zostaje, karta techniczna startuje od zera (zgłoszenie poszło), a człowiek
         wraca do swojego wniosku. Bez rozpoczętego wniosku — dokładnie jak dotąd. */
      const wniosekCzeka = wniosekWypelnionyRef.current && wnioskiDostepneRef.current;
      success(wniosekCzeka
        ? "Zgłoszenie zostało utworzone. Rozpoczęty wniosek czeka na dokończenie w karcie „Wnioski pracownicze”."
        : "Zgłoszenie zostało utworzone.");
      // Zgloszenie poszlo — szkic przestaje byc potrzebny i NIE MOZE wrocic przy nastepnym otwarciu.
      wyczyscSzkic(user?.id);
      if (wniosekCzeka) {
        resetForm();
        wybierzKarte(KARTA.wnioski);
        return;
      }
      zamknij(true);
    } catch (err) {
      console.error(err);
      toastError(err.response?.data?.message || "Nie udało się utworzyć zgłoszenia.");
    } finally {
      setLoading(false);
    }
  };

  /* ═══════════════════════════════════════════════════════════
     RENDER HELPERS
     ═══════════════════════════════════════════════════════════ */

  /* ─── SLA PILLS (header strip) ─── */
  const renderSlaStrip = () => {
    /* [zgłoszenie właściciela 2026-09-17] BRAMKA PASKA BYŁA POSTAWIONA NA NIEWŁAŚCIWYM POLU.
       Warunek `!matchedCategory.priority` chował CAŁY pasek — razem z czasami — gdy kategoria nie miała
       WŁASNEJ etykiety priorytetu. Kategorie z kreatora własnej nie mają, więc pracownik wybierający je
       nie widział ani priorytetu, ani czasów, choć okno miało jedno i drugie. Poprawka czasów z 16.09
       była w tym miejscu martwa: liczyła wartości, których nic nie pokazywało.
       TERAZ pasek pojawia się, gdy obowiązuje CHOĆ JEDNA z trzech wartości — własna albo z okna.
       Sama reguła mieszka w `plakietkiSlaKategorii`, żeby dało się ją sprawdzić bez montowania okna. */
    const plakietki = plakietkiSlaKategorii(matchedCategory);
    if (!plakietki) return null;
    const { priorytet, reakcja, rozwiazanie } = plakietki;
    return (
      <div className={s.slaStrip} data-testid="pasek-sla-kategorii">
        {priorytet && (
          <span className={`${s.slaPill} ${s.slaPillPriority}`}>
            <FiAlertTriangle size={11} /> {priorytet}
          </span>
        )}
        {/* [zgłoszenie właściciela 2026-09-16] Czas OBOWIĄZUJĄCY — własny kategorii albo
            odziedziczony z okna. Kategorie z kreatora własnych nie mają, więc pracownik nie
            widział tu żadnego terminu, choć okno je miało. Patrz `czasReakcjiKategorii`. */}
        {reakcja && (
          <span className={`${s.slaPill} ${s.slaPillReaction}`}>
            <FiZap size={11} /> {reakcja}
          </span>
        )}
        {rozwiazanie && (
          <span className={`${s.slaPill} ${s.slaPillResolution}`}>
            <FiClock size={11} /> {rozwiazanie}
          </span>
        )}
      </div>
    );
  };

  /* ─── SLA NOTE (below header if exists) ─── */
  const renderSlaNote = () => {
    if (!matchedCategory || !matchedCategory.notes) return null;
    return <div className={s.slaNote}>{matchedCategory.notes}</div>;
  };

  /* ─── DROP ZONE ─── */
  const renderDropZone = () => (
    <>
      {/* [OBSZAR D 2026-09-11] Wlasciciel: "dodaj do KAZDEGO zgloszenia (...) dodania osob".
          Blok stoi TUTAJ, a nie przy piaciu osobnych formularzach typow, wlasnie dlatego:
          piec miejsc wstawienia to piec okazji, zeby jedno pominac — i akurat ten jeden typ
          zgloszenia nie mialby jak dopisac nikogo, bez zadnego sladu, ze czegos brakuje. */}
      <DodatkoweOsoby wybrani={dodatkoweOsoby} onZmiana={setDodatkoweOsoby} disabled={loading} />

      <div
        className={`${s.dropZone} ${isDragging ? s.dropZoneActive : ""}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
      >
        <FiUploadCloud className={s.dropIcon} />
        <span className={s.dropText}>Przeciągnij pliki lub kliknij aby wybrać</span>
        <span className={s.dropHint}>PDF, Word, obrazy — maks. 25 MB</span>
        <input ref={fileInputRef} type="file" multiple onChange={handleFileChange} hidden />
      </div>
      {files.length > 0 && (
        <div className={s.fileList}>
          {files.map((f, i) => (
            <span key={`${f.name}-${i}`} className={s.fileChip}>
              <FiFile size={12} />
              {f.name}
              <button type="button" onClick={() => removeFile(i)} className={s.fileChipX}>
                <FiX size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
    </>
  );

  /* ═══════════════════════════════════════════════════════════
     RENDER: FORM BODY PER TYPE
     ═══════════════════════════════════════════════════════════ */

  // [K2] Informacja dla pracownika: gdzie trafi zgłoszenie (dział) i który moduł je obsłuży.
  // [c) brief właściciela 2026-09-03] Dołożony ADRES SKRZYNKI: „ma też info w zakresie jak to
  // padnie mu na skrzynkę, na przykładzie techniczny@krosno.com (per firma)". Adres bierzemy
  // z diagnostyki okien (GET /api/categories/tile-visibility), która wydaje go WYŁĄCZNIE dla
  // okien widocznych dla tego pracownika — czyli dla desku, do którego właśnie pisze, a nie
  // dla katalogu wszystkich skrzynek operacyjnych firmy (zawężenie względem A17-13).
  const renderRoutingInfo = () => {
    const cat = selectedTileCategory || sourceTileCategory;
    const diag = cat ? (tilesDiagnostic?.tiles || []).find((t) => String(t.id) === String(cat.id)) : null;
    const dept = cat?.handlingDepartment?.name || diag?.routingDepartment;
    const mod = (cat?.module ? moduleNameByCode[cat.module] : null) || diag?.routingModuleName;
    const skrzynka = diag?.routingMailbox;
    if (!dept && !mod && !skrzynka) return null;
    /* ── [polecenie właściciela 2026-09-19] „te badge były na dole okna, to są informacje mało istotne” ──
       BYŁO ŹLE DWA RAZY. (1) Cały wygląd niósł styl wpisany wprost w znacznik, w PIKSELACH i na
       twardych kolorach (`#059669`, `rgba(5,150,105,.08)`) — na ciemnym motywie zielona ramka świeciła,
       bo żaden z tych kolorów nie ma wariantu nocnego. To ta sama usterka, co przy selekcie desku
       w karcie zgłoszenia: kontrolka „obok” systemu stylów (poz.16 2026-09-04).
       (2) Zielone pudło na całą szerokość było NAJMOCNIEJSZYM elementem formularza wykupu — jedyną
       treścią, jaką widać na zrzucie właściciela pod rzędem ikon. Informacja o tym, który dział
       obsłuży sprawę, nie jest czynnością do wykonania; jest przypisem. Teraz to pasek plakietek
       z tokenów `--color-*`, stojący na KOŃCU formularza. */
    return (
      <div className={s.routingPasek} data-testid="pasek-routingu">
        <FiCheckCircle size={13} className={s.routingIkona} />
        <span className={s.routingTekst}>
          Trafi do {dept ? <strong>{dept}</strong> : "działu obsługującego"}{mod ? <> · moduł <strong>{mod}</strong></> : null}
          {skrzynka ? <> · skrzynka <strong>{skrzynka}</strong></> : null}
        </span>
      </div>
    );
  };

  // [G1] Wspólne elementy kafelka: informacja o przekazaniu + podkategorie + pola własne.
  const renderTileForwardInfo = () => {
    if (!selectedTileCategory?.forwardToEmail) return null;
    // [poz.16 2026-09-04] BYŁO: `s.sapInfoBox || s.infoBox` — klasa `sapInfoBox` nie istnieje
    // w arkuszu, a cały wygląd niosły style inline zapisane w PIKSELACH. To ta sama usterka,
    // co przy selekcie desku w karcie zgłoszenia: kontrolka „obok" systemu stylów.
    // Teraz: istniejąca klasa `infoBox` (ma też wariant ciemnego motywu, którego wersja inline
    // nie miała — na ciemnym tle ramka indygo świeciła).
    return (
      <div className={s.infoBox}>
        <FiInfo size={16} className={s.infoBoxIcon} />
        <span>
          Zgłoszenie zostanie automatycznie przekazane do <strong>{selectedTileCategory.forwardToEmail}</strong>.
          {selectedTileCategory.forwardCcReporter !== false && " Kopia trafi na Twój adres e-mail."}
          {" "}Twoje dane kontaktowe z książki adresowej zostaną dołączone automatycznie.
        </span>
      </div>
    );
  };

  /* [S25 2026-09-14] „Kategoria szczegółowa” pracownika — ta sama lista co u obsługi (PoleKategorii):
     SEKCJA = nazwa wybranego okna, pod nią jego kategorie, z szukaniem. Okno jest już wybrane kafelkiem,
     więc drzewo składa się z tego okna i jego kategorii (reguła: drzewoKategoriiZgloszenia.js).
     Walidacja „wybierz kategorię szczegółową” (B-9f) zostaje bez zmian — ramka błędu idzie na obudowę. */
  const drzewoPodkategoriiOkna = useMemo(
    () => (selectedTileCategory
      ? zbudujDrzewoKategorii([selectedTileCategory, ...tileSubcategories], { tylkoAktywne: true })
      : { grouped: [], orphans: [] }),
    [selectedTileCategory, tileSubcategories]
  );

  const renderTileSubcategorySelect = () => {
    if (tileSubcategories.length === 0) return null;
    return (
      <div className={s.field}>
        <label className={s.label} htmlFor="tileSubcategory">Kategoria szczegółowa <span className={s.req}>*</span></label>
        <div
          className={showErrors && formErrors.tileSubcategory ? s.poleKategoriiBlad : ""}
          data-pole-podkategorii
        >
          <PoleKategorii
            idPola="tileSubcategory"
            wartosc={tileSubcategoryId}
            onZmiana={setTileSubcategoryId}
            drzewo={drzewoPodkategoriiOkna}
            pokazModul={false}
          />
        </div>
        {fieldError("tileSubcategory")}
      </div>
    );
  };

  // [K3] Strukturalny słownik wartości pól własnych {etykieta: wartość} — zapisywany w Ticket.FormDataJson.
  /* [DLA KOGO 2026-09-19] Pola własne kafelka jako OBIEKT — żeby dało się je złączyć z innymi
     danymi formularza (np. „dla kogo” z pozycji zapotrzebowania) w jeden `FormDataJson`.
     Dwa osobne `FormDataJson` w jednym FormData nie istnieją: drugi `append` nie nadpisuje
     pierwszego, tylko dokłada drugą wartość pod tym samym kluczem, a serwer czyta jedną. */
  const buildFieldDataObject = () => {
    const obj = {};
    tileFieldDefs.forEach((f) => {
      const raw = tileCustomFields[f.id];
      obj[f.label] = f.fieldType === "checkbox" ? (raw ? "Tak" : "Nie")
        : f.fieldType === "file" ? (raw ? raw.name : "")
        : (raw ?? "");
    });
    return obj;
  };

  const buildFieldDataJson = () => {
    if (!tileFieldDefs.length) return null;
    return JSON.stringify(buildFieldDataObject());
  };

  const renderTileCustomFields = () => tileFieldDefs.map((f) => {
    const val = tileCustomFields[f.id];
    const set = (v) => setTileCustomFields((prev) => ({ ...prev, [f.id]: v }));
    const errCls = showErrors && formErrors[`tileField_${f.id}`] ? s.inputError : "";
    let options = [];
    if (f.fieldType === "select") {
      try { options = JSON.parse(f.optionsJson || "[]") || []; } catch { options = []; }
    }
    return (
      <div className={s.field} key={f.id}>
        <label className={s.label}>{f.label} {f.isRequired && <span className={s.req}>*</span>}</label>
        {f.fieldType === "textarea" ? (
          <textarea rows={4} value={val || ""} onChange={(e) => set(e.target.value)} placeholder={f.placeholder || ""} className={`${s.textarea} ${errCls}`} />
        ) : f.fieldType === "select" ? (
          <select value={val || ""} onChange={(e) => set(e.target.value)} className={`${s.select} ${errCls}`}>
            <option value="">— Wybierz —</option>
            {options.map((o, i) => <option key={i} value={o}>{o}</option>)}
          </select>
        ) : f.fieldType === "checkbox" ? (
          <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
            <input type="checkbox" checked={!!val} onChange={(e) => set(e.target.checked)} />
            <span>{f.placeholder || "Tak"}</span>
          </label>
        ) : f.fieldType === "file" ? (
          <div>
            <input type="file" onChange={(e) => set(e.target.files?.[0] || null)} className={`${s.input} ${errCls}`} />
            {val && <span style={{ fontSize: "0.78rem", color: "var(--color-text-secondary)", marginTop: 4, display: "inline-block" }}>📎 {val.name}</span>}
          </div>
        ) : f.fieldType === "date" ? (
          /* [R22] Jedyny typ datowy konfiguratora (whitelist KonfiguratorZgloszenReguly: text/textarea/number/
             date/select/checkbox/file) — stąd DatePicker; godziny ani daty z godziną kafelek nie ma.
             Picker oddaje "RRRR-MM-DD" albo "" — ten sam zapis co natywne pole, więc FormDataJson i treść bez zmian. */
          <DatePicker
            value={val || ""}
            onChange={set}
            placeholder={f.placeholder || "Wybierz datę"}
            ariaLabel={f.label}
            className={errCls}
          />
        ) : (
          <input
            type={f.fieldType === "number" ? "number" : "text"}
            value={val || ""} onChange={(e) => set(e.target.value)}
            placeholder={f.placeholder || ""} className={`${s.input} ${errCls}`}
          />
        )}
        {fieldError(`tileField_${f.id}`)}
      </div>
    );
  });

  /* [polecenie właściciela 2026-09-20] „w oknie modal, jak składam zgłoszenie HR, ma być informacja,
     że złożone zgłoszenie nie ma charakteru wykonawczego a służy jako konsultacja, w celu realizacji
     postanowień zgłoszenia pracownik i tak musi złożyć odpowiedni w tym celu wniosek w sekcji
     wnioski-hr — daj link".
     Komunikat stoi przy KAŻDYM oknie modułu `hr` (rozpoznanie po module okna, nie po liście nazw —
     lista rozjechałaby się przy pierwszym nowym oknie w konfiguratorze). Odsyłacz nawiguje przez
     `localizedPath` (reguła tras dwujęzycznych) i zamyka okno — inaczej po przejściu do wniosków
     modal wisiałby nad nową stroną. */
  const renderHrKonsultacjaInfo = () => {
    if (selectedTileCategory?.module !== "hr") return null;
    return (
      <div className={s.infoBox} data-testid="hr-konsultacja-info">
        <FiInfo size={16} className={s.infoBoxIcon} />
        <span>
          Zgłoszenie kadrowe <strong>nie ma charakteru wykonawczego</strong> — służy jako konsultacja
          z działem HR. Aby zrealizować sprawę, złóż odpowiedni wniosek
          {/* [poprawka 2026-09-28] To samo okno ma kartę wniosków — przejście do niej jest bliższe niż wyjście na stronę. */}
          {wnioskiDostepne && (
            <>
              {" "}w karcie{" "}
              <button type="button" className={s.przejdzDoKarty} onClick={() => wybierzKarte(KARTA.wnioski)}
                data-testid="hr-konsultacja-do-karty-wnioskow">
                „Wnioski pracownicze”
              </button>{" "}
              tego okna albo
            </>
          )}
          {" "}w sekcji{" "}
          <OdsylaczDoWnioskowHr zamknij={zamknij} czyWniosekWypelniony={czyWniosekWypelniony}
            poPorzuceniuWniosku={poPorzuceniuWniosku} />.
        </span>
      </div>
    );
  };

  // [F2] Formularz dynamicznego kafelka: generic (temat+opis) lub requisition (lista pozycji).
  const renderTileFormBody = () => {
    if (selectedTileCategory.tileFormKind === "requisition") {
      return (
        <div className={s.formSection}>
          {renderHrKonsultacjaInfo()}
          {/* Informacja o PRZEKAZANIU zostaje na górze — to nie przypis, tylko skutek wysłania
              (sprawa wyjdzie poza aplikację). Pasek „trafi do działu X” zszedł na dół formularza. */}
          {renderTileForwardInfo()}
          {renderTileSubcategorySelect()}
          <div className={s.field}>
            <label className={s.label}>Pozycje zapotrzebowania <span className={s.req}>*</span></label>
            {tileItems.map((item, idx) => (
              <div key={item.id} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "flex-start", flexWrap: "wrap" }}>
                <input
                  type="text" placeholder="Nazwa pozycji / link"
                  value={item.name}
                  onChange={(e) => setTileItems((prev) => prev.map((it) => it.id === item.id ? { ...it, name: e.target.value } : it))}
                  className={`${s.input} ${showErrors && formErrors[`tileItemName_${idx}`] ? s.inputError : ""}`}
                  style={{ flex: "2 1 220px" }}
                />
                <input
                  type="number" min={1} placeholder="Ilość"
                  value={item.quantity}
                  onChange={(e) => setTileItems((prev) => prev.map((it) => it.id === item.id ? { ...it, quantity: Number(e.target.value) } : it))}
                  className={`${s.input} ${showErrors && formErrors[`tileItemQty_${idx}`] ? s.inputError : ""}`}
                  style={{ flex: "0 0 90px" }}
                />
                <input
                  type="text" placeholder="Uwagi (opcjonalnie)"
                  value={item.note}
                  onChange={(e) => setTileItems((prev) => prev.map((it) => it.id === item.id ? { ...it, note: e.target.value } : it))}
                  className={s.input}
                  style={{ flex: "1 1 160px" }}
                />
                {tileItems.length > 1 && (
                  <button type="button" className={s.btnCancel} style={{ padding: "8px 10px" }}
                    onClick={() => setTileItems((prev) => prev.filter((it) => it.id !== item.id))}>
                    <FiTrash2 size={14} />
                  </button>
                )}
              </div>
            ))}
            <button type="button" className={s.backPill}
              onClick={() => setTileItems((prev) => [...prev, { id: Date.now(), name: "", quantity: 1, note: "" }])}>
              <FiPlus size={14} /> Dodaj pozycję
            </button>
          </div>
          {renderTileCustomFields()}
          <div className={s.field}>
          <label className={s.label}>Priorytet</label>
          <select value={priority} onChange={(e) => setPriority(Number(e.target.value))} className={s.select}>
            <option value={TICKET_PRIORITY.LOW}>Niski</option>
            <option value={TICKET_PRIORITY.MEDIUM}>Średni</option>
            <option value={TICKET_PRIORITY.HIGH}>Wysoki</option>
          </select>
        </div>
        {renderDropZone()}
        {renderRoutingInfo()}
        </div>
      );
    }
    return (
      <div className={s.formSection}>
        {renderHrKonsultacjaInfo()}
        {renderTileForwardInfo()}
        {renderTileSubcategorySelect()}
        <div className={s.field}>
          <label className={s.label}>Temat <span className={s.req}>*</span></label>
          <input
            type="text" value={tileSubject}
            onChange={(e) => setTileSubject(e.target.value)}
            placeholder="Czego dotyczy zgłoszenie?"
            className={`${s.input} ${showErrors && formErrors.tileSubject ? s.inputError : ""}`}
          />
          {fieldError("tileSubject")}
        </div>
        <div className={s.field}>
          <label className={s.label}>Opis <span className={s.req}>*</span></label>
          <textarea
            rows={6} value={tileBody}
            onChange={(e) => setTileBody(e.target.value)}
            placeholder="Opisz szczegóły zgłoszenia…"
            className={`${s.textarea} ${showErrors && formErrors.tileBody ? s.inputError : ""}`}
          />
          {fieldError("tileBody")}
        </div>
        {renderTileCustomFields()}
        <div className={s.field}>
          <label className={s.label}>Priorytet</label>
          <select value={priority} onChange={(e) => setPriority(Number(e.target.value))} className={s.select}>
            <option value={TICKET_PRIORITY.LOW}>Niski</option>
            <option value={TICKET_PRIORITY.MEDIUM}>Średni</option>
            <option value={TICKET_PRIORITY.HIGH}>Wysoki</option>
          </select>
        </div>
        {renderDropZone()}
        {renderRoutingInfo()}
      </div>
    );
  };

  const renderFormBody = () => {
    if (selectedTileCategory) return renderTileFormBody();
    switch (selectedType) {
      /* ──── TECHNICAL ──── */
      case TICKET_TYPE.TECHNICAL: {
        const catObj = categories.find((c) => c.id === categoryId);
        const categoryType = catObj ? catObj.type : null;
        return (
          <div className={s.formSection}>
            <div className={s.field}>
              <label className={s.label}>Kategoria problemu <span className={s.req}>*</span></label>
              <select value={categoryId} onChange={handleCategoryChange} className={`${s.select} ${showErrors && formErrors.categoryId ? s.inputError : ""}`}>
                <option value="">— Wybierz kategorię —</option>
                {technicalCategoryTree.grouped.map(({ group, leaves }) => (
                  <optgroup key={group.id} label={group.name}>
                    {leaves.map((c) => (
                      <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                  </optgroup>
                ))}
                {technicalCategoryTree.orphans.length > 0 && technicalCategoryTree.grouped.length > 0 ? (
                  <optgroup label="Inne">
                    {technicalCategoryTree.orphans.map((c) => (
                      <option key={c.id} value={c.id}>{c.name}</option>
                    ))}
                  </optgroup>
                ) : (
                  technicalCategoryTree.orphans.map((c) => (
                    <option key={c.id} value={c.id}>{c.name}</option>
                  ))
                )}
              </select>
              {fieldError("categoryId")}
            </div>
            {categoryId && renderDynamicFields(categoryType, dynamicFields, handleDynamicFieldChange)}
            {categoryId && (
              <>
                {fieldError("passwordType")}
                {fieldError("printerNumber")}
                {fieldError("phoneProblem")}
                {fieldError("description")}
                <div className={s.field}>
                  <label className={s.label}>Priorytet</label>
                  <select value={priority} onChange={(e) => setPriority(Number(e.target.value))} className={s.select}>
                    <option value={TICKET_PRIORITY.LOW}>Niski</option>
                    <option value={TICKET_PRIORITY.MEDIUM}>Średni</option>
                    <option value={TICKET_PRIORITY.HIGH}>Wysoki</option>
                  </select>
                </div>
                {renderDropZone()}
              </>
            )}
          </div>
        );
      }

      /* ──── DRIVE ACCESS ──── */
      case TICKET_TYPE.DRIVE_ACCESS: {
        // [przegląd R19] Podsumowanie z pamięci karty — wybrany dysk nie znika, gdy fraza go nie obejmuje.
        const wybraneObiekty = wybraneDyski(znaneDyskiRef.current, selectedDrives, drivesGroups);
        const selectedCount = selectedDrives.length;
        return (
          <div className={s.formSection}>
            {renderSlaNote()}

            {/* ═══ [BH 2026-09-19] ZAKRES WNIOSKU — SPÓŁKA, RODZAJ ZASOBU, DLA KOGO ═══
                Stoi NAD listą, bo dwie pierwsze rzeczy ją ZAWĘŻAJĄ. Zrzut właściciela pokazuje przy
                liście licznik „332 zasoby”: bez zawężenia wybór właściwego dysku to przewijanie
                kilkuset wierszy, a to nie jest formularz, tylko labirynt. */}
            <div className={s.zakresWniosku} data-testid="zakres-wniosku-o-zasoby">
              <div className={s.zakresGlowica}>
                <FiFilter size={14} />
                <span>Zakres wniosku</span>
              </div>
              <div className={s.zakresPola}>
                {/* Spółka: „firma z definicji do wyboru” — słownik, nie wolne pole tekstowe.
                    Gdy słownika nie ma (starszy serwer, brak dostępu), pole się nie pojawia,
                    a wniosek idzie bez zawężenia — czyli dokładnie jak przed tą falą. */}
                {spolki.length > 0 && (
                  <div className={s.field}>
                    <label className={s.label} htmlFor="wniosek-spolka">Spółka, do której należy zasób</label>
                    <select
                      id="wniosek-spolka"
                      className={s.select}
                      value={spolkaWniosku}
                      onChange={handleSpolkaChange}
                      data-testid="wniosek-spolka"
                    >
                      <option value="">Wszystkie spółki</option>
                      {spolki.map((sp) => (
                        <option key={sp.id} value={sp.id}>{sp.name}</option>
                      ))}
                    </select>
                    <span className={s.zakresPodpowiedz}>
                      Zasoby bez przypisanej spółki są widoczne przy każdym wyborze.
                    </span>
                  </div>
                )}

                {/* Rodzaj zasobu — „dodaj opcję złożenia dysku sieciowego sharepoint”.
                    Witryny SharePoint były na liście od 13.09, ale nie dało się poprosić WYŁĄCZNIE
                    o nie, a to inny wniosek i inna droga realizacji w IT. */}
                <div className={s.field}>
                  <span className={s.label}>Rodzaj zasobu</span>
                  <div className={s.zakresPrzelacznik} role="group" aria-label="Rodzaj zasobu">
                    {Object.values(RODZAJ_ZASOBU).map((r) => (
                      <button
                        key={r || "wszystkie"}
                        type="button"
                        className={`${s.zakresOpcja} ${rodzajZasobu === r ? s.zakresOpcjaWybrana : ""}`}
                        aria-pressed={rodzajZasobu === r}
                        onClick={() => handleRodzajZasobuChange(r)}
                        data-testid={`wniosek-rodzaj-${r || "wszystkie"}`}
                      >
                        {r === RODZAJ_ZASOBU.sharepoint ? <FiCloud size={13} />
                          : r === RODZAJ_ZASOBU.siec ? <FiServer size={13} /> : <FiFolder size={13} />}
                        {ETYKIETY_RODZAJU[r]}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* „dodaj też koniecznie w polach, dla kogo ma być nadany dostęp — wyszukiwanie po
                  pracownikach z aplikacji, jako dodanie nawet kilku osób”. TA SAMA kontrolka, co
                  przy dopisywaniu osób do zgłoszenia — druga kopia rozjechałaby się przy pierwszej
                  poprawce (przechwycenie Entera w tym polu powstało po wypadku). */}
              <DodatkoweOsoby
                wybrani={osobyDostepu}
                onZmiana={setOsobyDostepu}
                disabled={loading}
                testId="dla-kogo-dostep"
                tytul="Dla kogo ma być nadany dostęp"
                wyjasnienie={"Wskaż osoby, którym ma zostać nadany dostęp — gospodarz zasobu decyduje osobno o każdej z nich. "
                  + "Nikogo nie wskazujesz, jeśli wnioskujesz dla siebie."}
                placeholder="Wyszukaj pracownika po imieniu, nazwisku lub adresie…"
                tekstPustegoStanu="Nikogo nie wskazano — wniosek dotyczy Ciebie."
              />
              {fieldError("osobyDostepu")}
            </div>

            {/* [POLECENIE WŁAŚCICIELA 2026-09-12] Wniosek o ZAŁOŻENIE zasobu, którego nie ma na liście.
                Przełącznik stoi NAD wyszukiwarką, bo człowiek, który nie znalazł swojego zasobu, szuka
                wyjścia właśnie tutaj — schowany niżej byłby nieodnajdywalny. Po zaznaczeniu lista
                przestaje być wymagana (walidacja przenosi się na formularz).
                [BH-2] O KTÓRY zasób chodzi, rozstrzyga wybrany wyżej rodzaj — witryna SharePoint ma
                własny formularz, bo nie ma ani udziału sieciowego, ani grup AD _RW/_RO. */}
            <label className={s.drvNewToggle}>
              <input
                type="checkbox"
                checked={chceNowyDysk}
                onChange={(e) => setChceNowyDysk(e.target.checked)}
                data-testid="wniosek-nowy-zasob"
              />
              <span>
                {rodzajZasobu === RODZAJ_ZASOBU.sharepoint
                  ? <>Potrzebuję <strong>założenia nowej witryny SharePoint</strong> — nie ma jej na liście</>
                  : <>Potrzebuję <strong>założenia nowego dysku</strong> — nie ma go na liście</>}
              </span>
            </label>
            {chceNowyDysk && (rodzajZasobu === RODZAJ_ZASOBU.sharepoint ? (
              <FormularzNowejWitrynySharePoint
                wartosc={nowaWitryna}
                onZmiana={setNowaWitryna}
                pokazBledy={showErrors}
              />
            ) : (
              <FormularzNowegoDysku
                wartosc={nowyDysk}
                onZmiana={setNowyDysk}
                pokazBledy={showErrors}
              />
            ))}

            {/* ─── Search bar with selected counter ─── */}
            <div className={s.drvSearchWrap}>
              <div className={s.drvSearchBox}>
                <FiSearch className={s.drvSearchIco} />
                <input
                  type="text"
                  placeholder={rodzajZasobu === RODZAJ_ZASOBU.sharepoint
                    ? "Szukaj witryny po nazwie, opisie lub dziale..."
                    : "Szukaj zasobu po nazwie, opisie, dziale lub adresie..."}
                  value={driveSearch}
                  onChange={handleDriveSearchChange}
                  className={s.drvSearchInput}
                />
                {selectedCount > 0 && (
                  <span className={s.drvSearchCounter}>
                    <FiCheckCircle size={12} /> {selectedCount}
                  </span>
                )}
              </div>
            </div>

            {/* ─── Selected drives summary ─── */}
            {selectedCount > 0 && (
              <div className={s.drvSummary}>
                <div className={s.drvSummaryHead}>
                  <FiShield size={14} />
                  <span>Wybrane dyski ({selectedCount})</span>
                </div>
                <div className={s.drvSummaryChips}>
                  {wybraneObiekty.map((d) => (
                    <span key={d.id} className={s.drvSummaryChip}>
                      <FiFolder size={12} />
                      <span className={s.drvSummaryChipName}>{nazwaDlaCzlowieka(d)}</span>
                      <span className={`${s.drvSummaryChipLevel} ${driveAccessLevels[d.id] === "read_write" ? s.drvLevelWrite : s.drvLevelRead}`}>
                        {driveAccessLevels[d.id] === "read_write" ? "R+W" : "R"}
                      </span>
                      <button type="button" className={s.drvSummaryChipX} onClick={() => handleDriveSelection(d.id, false)}>
                        <FiX size={11} />
                      </button>
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* ─── Lista zasobow [R19/R20 2026-09-13] ───
                Gesty wiersz (~2,5 rem): nazwa kanoniczna, sciezka bez sufiksu RW/RO, opis i DZIAL; opiekun
                wylacznie w podpowiedzi. Jedna przewijana lista z przyklejonymi naglowkami grup. */}
            <ListaDyskowDoWniosku
              grupy={drivesGroups}
              ladowanie={loadingDrives}
              wybrane={selectedDrives}
              poziomy={driveAccessLevels}
              rozwiniete={expandedGroups}
              onPrzelaczGrupe={toggleGroup}
              onZaznacz={handleDriveSelection}
              onPoziom={handleDriveAccessLevelChange}
            />

            {fieldError("drives")}

            {/* ─── Info instruction ─── */}
            <div className={s.drvInfoBox}>
              <FiInfo className={s.drvInfoIcon} />
              {/* [BH-3 2026-09-19] Zdanie musi mówić o tym, CO SIĘ STANIE przy wniosku dla kilku osób:
                  decyzja zapada OSOBNO dla każdej z nich (jeden wiersz = jedna para zasób × osoba),
                  więc „przyznano" nie jest odpowiedzią na cały wniosek. Bez tego człowiek wskazuje
                  trzy osoby i spodziewa się jednej odpowiedzi na wszystkie trzy. */}
              <p>
                Zaznacz zasoby, do których potrzebny jest dostęp. Gospodarz każdego zasobu dostanie link
                do decyzji i rozstrzyga <strong>osobno dla każdej wskazanej osoby</strong>; przyznany dostęp
                przypisuje się w systemie automatycznie.
              </p>
            </div>
          </div>
        );
      }

      /* ──── EQUIPMENT BUYOUT ──── */
      case TICKET_TYPE.EQUIPMENT_BUYOUT: {
        /* [polecenie właściciela 2026-09-19] „POPRAW UI dla sekcji (…) w kategorii Wykup sprzętu”.
           Kroki istniały wyłącznie jako kolejność warunków w renderze — czyli nigdzie na ekranie.
           Regułę „na którym kroku jestem” liczy `wykupSprzetu`, bo ma dwie postacie kroku 2. */
        const krok = krokWykupu({
          typ: buyoutData.type,
          liczbaUrzadzen: filteredMyDevices.length,
          wybraneUrzadzenie: selectedBuyoutDevice,
          numerRecznie: buyoutData.hardwareId,
        });
        return (
          <div className={s.formSection}>
            {renderSlaNote()}

            {/* ─── Pasek kroków: ile jeszcze przed człowiekiem ─── */}
            <ol className={s.krokiPasek} data-testid="kroki-wykupu">
              {KROKI_WYKUPU.map((k) => (
                <li
                  key={k.nr}
                  className={`${s.krok} ${krok === k.nr ? s.krokAktywny : ""} ${krok > k.nr ? s.krokZrobiony : ""}`}
                  data-krok={k.nr}
                  aria-current={krok === k.nr ? "step" : undefined}
                >
                  <span className={s.krokNumer}>{krok > k.nr ? <FiCheckCircle size={13} /> : k.nr}</span>
                  <span className={s.krokTresc}>
                    <span className={s.krokTytul}>{k.tytul}</span>
                    <span className={s.krokOpis}>{k.opis}</span>
                  </span>
                </li>
              ))}
            </ol>

            {/* ─── 1. Equipment type selection ─── */}
            <div className={s.field}>
              <label className={s.label}>Wybierz typ sprzętu do wykupu <span className={s.req}>*</span></label>
              {/* [2026-09-20] PUSTA LISTA TYPÓW TO ODPOWIEDŹ, NIE AWARIA. Gdy żaden typ nie ma
                  włączonego „można wykupić”, okno pokazywałoby pusty prostokąt i nie dawało się
                  wysłać — człowiek nie wiedziałby, czy to błąd, czy reguła. Mówimy wprost. */}
              {typyDoWykupu.length === 0 ? (
                <div className={s.buyEmptyDevices} data-testid="wykup-brak-typow">
                  <FiShoppingCart className={s.buyEmptyIcon} />
                  <span className={s.buyEmptyTitle}>Żaden sprzęt nie podlega dziś wykupowi</span>
                  <span className={s.buyEmptyHint}>
                    Lista sprzętu, który można wykupić, jest ustawiana przy typach urządzeń w ewidencji IT.
                    Jeśli uważasz, że Twój sprzęt powinien się tu znaleźć — napisz do działu IT.
                  </span>
                </div>
              ) : (
              <div className={s.buyTypeGrid}>
                {typyDoWykupu.map((t) => (
                  <button
                    key={t.id}
                    type="button"
                    className={`${s.buyTypeCard} ${buyoutData.type === t.name ? s.buyTypeCardActive : ""}`}
                    onClick={() => handleBuyoutTypeChange(t.name)}
                  >
                    <span className={s.buyTypeIcon}>
                      {(() => { const Ico = ICON_MAP[t.icon]; return Ico ? <Ico size={24} /> : <FiPackage size={24} />; })()}
                    </span>
                    <span className={s.buyTypeName}>{t.name}</span>
                  </button>
                ))}
              </div>
              )}
              {fieldError("buyoutType")}
            </div>

            {/* ─── Pusty stan (W-1): treść zamiast martwego pola ───
                Do tej fali po wejściu w okno widać było rząd ikon, zielone pudło i NIC więcej —
                reszta okna była pusta, a człowiek nie wiedział, czy to już koniec formularza.
                Biała karta mówi, co się stanie po wyborze, i zajmuje miejsce, które i tak stoi puste. */}
            {!buyoutData.type && (
              <div className={s.buyEmptyDevices} data-testid="wykup-pusty-stan">
                <FiShoppingCart className={s.buyEmptyIcon} />
                <span className={s.buyEmptyTitle}>Zacznij od typu sprzętu</span>
                <span className={s.buyEmptyHint}>
                  Po wybraniu typu pokażemy sprzęt <strong>przypisany do Ciebie</strong> w ewidencji ITAM —
                  wystarczy wskazać urządzenie i potwierdzić numery seryjne. Jeśli nic nie będzie
                  przypisane, wpiszesz numer ręcznie. Na końcu podasz powód wykupu.
                </span>
              </div>
            )}

            {/* ─── 2. Assigned devices or manual entry ─── */}
            {buyoutData.type && (
              <>
                {loadingMyDevices ? (
                  <div className={s.buyLoading}>
                    <div className={s.buySpinner} />
                    <span>Szukam sprzętu przypisanego do Ciebie...</span>
                  </div>
                ) : filteredMyDevices.length > 0 ? (
                  <>
                    {/* ─── Assigned devices list ─── */}
                    <div className={s.buyInfoBox}>
                      <FiInfo className={s.buyInfoIcon} />
                      <p>Poniżej wyświetlono sprzęt typu <strong>{buyoutData.type}</strong> przypisany do Twojego konta. Wybierz urządzenie, które chcesz wykupić i potwierdź numery seryjne.</p>
                    </div>

                    {filteredMyDevices.map((device) => {
                      const isSelected = selectedBuyoutDevice?.id === device.id;
                      return (
                        <div
                          key={device.id}
                          className={`${s.buyDeviceCard} ${isSelected ? s.buyDeviceCardSelected : ""}`}
                        >
                          <div
                            className={s.buyDeviceTop}
                            onClick={() => handleSelectBuyoutDevice(device)}
                          >
                            <div className={s.buyDeviceIcon}>
                              <FiCpu size={20} />
                            </div>
                            <div className={s.buyDeviceMeta}>
                              <span className={s.buyDeviceName}>
                                {device.deviceName || device.deviceModel || "Urządzenie"}
                              </span>
                              <span className={s.buyDeviceModel}>
                                {[device.deviceManufacturer, device.deviceModel].filter(Boolean).join(" ") || "Brak modelu"}
                              </span>
                              <div className={s.buyDevicePills}>
                                <span className={s.buyAssignedBadge}>
                                  <FiCheckCircle size={10} /> Przypisane do Ciebie
                                </span>
                                {device.inventoryNumber && (
                                  <span className={s.buyDevicePill}>INV: {device.inventoryNumber}</span>
                                )}
                                {device.condition && (
                                  <span className={s.buyDevicePill}>{device.condition}</span>
                                )}
                              </div>
                            </div>
                            <div className={`${s.buyDeviceCheck} ${isSelected ? s.buyDeviceCheckActive : ""}`}>
                              {isSelected ? <FiCheckCircle size={22} /> : <div className={s.drvCardCheckEmpty} />}
                            </div>
                          </div>

                          {/* ─── Serial number confirmation section ─── */}
                          {isSelected && (
                            <>
                              <div className={s.buySerialSection}>
                                {device.deviceSerialNumber && (
                                  <div className={s.buySerialRow}>
                                    <span className={s.buySerialLabel}>Numer seryjny</span>
                                    <span className={s.buySerialValue}>{device.deviceSerialNumber}</span>
                                  </div>
                                )}
                                {device.deviceImei && (
                                  <div className={s.buySerialRow}>
                                    <span className={s.buySerialLabel}>IMEI</span>
                                    <span className={s.buySerialValue}>{device.deviceImei}</span>
                                  </div>
                                )}
                                {device.inventoryNumber && (
                                  <div className={s.buySerialRow}>
                                    <span className={s.buySerialLabel}>Nr inwent.</span>
                                    <span className={s.buySerialValue}>{device.inventoryNumber}</span>
                                  </div>
                                )}

                                {/* Confirm serial numbers */}
                                <div
                                  className={`${s.buySerialConfirm} ${serialConfirmed ? s.buySerialConfirmActive : ""}`}
                                  onClick={toggleSerialConfirm}
                                >
                                  <div className={`${s.buySerialCheckbox} ${serialConfirmed ? s.buySerialCheckboxActive : ""}`}>
                                    {serialConfirmed && <FiCheckCircle size={14} />}
                                  </div>
                                  <span className={s.buySerialConfirmText}>
                                    Potwierdzam, że powyższe numery seryjne są prawidłowe i zgadzają się ze sprzętem w moim posiadaniu.
                                  </span>
                                </div>

                                {/* Serial mismatch option */}
                                {!serialConfirmed && (
                                  <div
                                    className={`${s.buySerialConfirm} ${s.buySerialConfirmCompact} ${serialMismatch ? s.buySerialConfirmActive : ""}`}
                                    onClick={toggleSerialMismatch}
                                    style={{ borderColor: serialMismatch ? "rgba(237, 137, 54, 0.4)" : undefined, background: serialMismatch ? "rgba(237, 137, 54, 0.08)" : undefined }}
                                  >
                                    <div className={`${s.buySerialCheckbox} ${serialMismatch ? s.buySerialCheckboxActive : ""}`} style={serialMismatch ? { background: "#ed8936", borderColor: "#ed8936" } : {}}>
                                      {serialMismatch && <FiAlertTriangle size={14} />}
                                    </div>
                                    <span className={s.buySerialConfirmText}>
                                      Numery seryjne <strong>nie zgadzają się</strong> — chcę podać aktualne numery.
                                    </span>
                                  </div>
                                )}
                              </div>

                              {/* ─── Corrected serials input ─── */}
                              {serialMismatch && (
                                <div className={s.buyMismatchSection}>
                                  <div className={s.buyMismatchBanner}>
                                    <FiAlertTriangle size={16} className={s.buyMismatchIcon} />
                                    <span className={s.buyMismatchText}>
                                      Niezgodność numerów seryjnych zostanie zgłoszona do działu IT w celu aktualizacji ewidencji. Wprowadź aktualne numery z urządzenia.
                                    </span>
                                  </div>
                                  <div className={s.buySerialRow}>
                                    <span className={s.buySerialLabel}>Aktualny S/N</span>
                                    <input
                                      type="text"
                                      value={correctedSerials.serial}
                                      onChange={(e) => setCorrectedSerials((p) => ({ ...p, serial: e.target.value }))}
                                      className={s.buyMismatchInput}
                                      placeholder="Wpisz prawidłowy numer seryjny..."
                                      required
                                    />
                                  </div>
                                  {device.deviceImei && (
                                    <div className={`${s.buySerialRow} mt-8`}>
                                      <span className={s.buySerialLabel}>Aktualny IMEI</span>
                                      <input
                                        type="text"
                                        value={correctedSerials.imei}
                                        onChange={(e) => setCorrectedSerials((p) => ({ ...p, imei: e.target.value }))}
                                        className={s.buyMismatchInput}
                                        placeholder="Wpisz prawidłowy numer IMEI..."
                                      />
                                    </div>
                                  )}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      );
                    })}
                    {fieldError("buyoutDevice")}
                    {fieldError("buyoutSerial")}
                    {fieldError("buyoutCorrectedSerial")}
                  </>
                ) : (
                  <>
                    {/* ─── No assigned devices — manual entry ─── */}
                    <div className={s.buyEmptyDevices}>
                      <FiPackage className={s.buyEmptyIcon} />
                      <span className={s.buyEmptyTitle}>Brak przypisanego sprzętu tego typu</span>
                      <span className={s.buyEmptyHint}>
                        Nie znaleziono sprzętu typu „{buyoutData.type}" przypisanego do Twojego konta. Wypełnij dane ręcznie poniżej.
                      </span>
                    </div>
                    <div className={s.buyManualEntry}>
                      <div className={s.buyManualTitle}>
                        <FiEdit size={16} /> Dane sprzętu
                      </div>
                      <div className={s.buyManualGrid}>
                        <div className={s.field}>
                          <label className={s.label}>Numer seryjny <span className={s.req}>*</span></label>
                          <input
                            type="text"
                            value={buyoutData.hardwareId}
                            onChange={(e) => setBuyoutData({ ...buyoutData, hardwareId: e.target.value })}
                            className={`${s.input} ${showErrors && formErrors.buyoutHardwareId ? s.inputError : ""}`}
                            placeholder="np. SN-2024-ABC123"
                          />
                          {fieldError("buyoutHardwareId")}
                        </div>
                        <div className={s.field}>
                          <label className={s.label}>Nr inwentarzowy (jeśli znany)</label>
                          <input
                            type="text"
                            value={buyoutData.inventoryNumber || ""}
                            onChange={(e) => setBuyoutData({ ...buyoutData, inventoryNumber: e.target.value })}
                            className={s.input}
                            placeholder="np. INV-2024-001"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* ─── 3. Reason (always shown when type selected) ─── */}
                <div className={s.field}>
                  <label className={s.label}>Powód wykupu <span className={s.req}>*</span></label>
                  <textarea
                    value={buyoutData.reason}
                    onChange={(e) => setBuyoutData({ ...buyoutData, reason: e.target.value })}
                    className={`${s.textarea} ${showErrors && formErrors.buyoutReason ? s.inputError : ""}`}
                    rows={4}
                    placeholder="Opisz powód wykupu sprzętu (min. 20 znaków)..."
                  />
                  {fieldError("buyoutReason")}
                </div>

                {renderDropZone()}
              </>
            )}
          </div>
        );
      }

      /* ──── EQUIPMENT REQUEST ──── */
      case TICKET_TYPE.EQUIPMENT_REQUEST:
        return (
          <div className={s.formSection}>
            {renderSlaNote()}
            {requestItems.map((item, idx) => (
              <div key={item.id} className={s.reqCard}>
                <div className={s.reqHeader}>
                  <span>Pozycja {idx + 1}</span>
                  {requestItems.length > 1 && (
                    <button type="button" onClick={() => removeRequestItem(item.id)} className={s.reqRemove}><FiTrash2 size={14} /></button>
                  )}
                </div>
                <div className={s.reqGrid}>
                  <div className={s.field}>
                    <label className={s.label}>Typ sprzętu <span className={s.req}>*</span></label>
                    <select value={item.type} onChange={(e) => updateRequestItem(item.id, "type", e.target.value)} className={`${s.select} ${showErrors && formErrors[`reqType_${idx}`] ? s.inputError : ""}`}>
                      <option value="">— Wybierz typ —</option>
                      {equipmentTypes.map((t) => (
                        <option key={t.id} value={t.name}>{t.name}</option>
                      ))}
                    </select>
                    {fieldError(`reqType_${idx}`)}
                  </div>
                  <div className={s.field}>
                    <label className={s.label}>Ilość <span className={s.req}>*</span></label>
                    <input type="number" min="1" value={item.quantity} onChange={(e) => updateRequestItem(item.id, "quantity", e.target.value)} className={`${s.input} ${showErrors && formErrors[`reqQty_${idx}`] ? s.inputError : ""}`} />
                    {fieldError(`reqQty_${idx}`)}
                  </div>
                  <div className={s.fieldFull}>
                    <label className={s.label}>Nazwa / link do przedmiotu <span className={s.req}>*</span></label>
                    <input type="text" value={item.nameOrSerial} onChange={(e) => updateRequestItem(item.id, "nameOrSerial", e.target.value)} className={`${s.input} ${showErrors && formErrors[`reqName_${idx}`] ? s.inputError : ""}`} placeholder="np. Dell Latitude 5540 lub link" />
                    {fieldError(`reqName_${idx}`)}
                  </div>
                  {/* [DLA KOGO 2026-09-19] Nie jedna kratka z napisem, tylko wyszukiwarka kont
                      + dwa pola (imię i nazwisko, dział) widoczne NARAZ. Zajmuje całą szerokość
                      karty pozycji, bo ściśnięta w kolumnę byłaby nieczytelna. */}
                  <div className={s.fieldFull}>
                    <WyborOsobyDlaKogo
                      pozycja={item}
                      idPozycji={item.id}
                      onZmiana={(patch) => updateRequestItemPatch(item.id, patch)}
                      blad={fieldError(`reqFor_${idx}`)}
                      bladKlasa={showErrors && formErrors[`reqFor_${idx}`] ? s.inputError : ""}
                    />
                  </div>
                </div>
              </div>
            ))}
            <button type="button" onClick={addRequestItem} className={s.addItemBtn}>
              <FiPlus /> Dodaj kolejną pozycję
            </button>
          </div>
        );

      /* ──── PERSONAL DATA ──── */
      case TICKET_TYPE.PERSONAL_DATA_CHANGE:
        return (
          <div className={s.formSection}>
            <div className={s.infoBox}>
              <FiInfo className={s.infoBoxIcon} />
              <p>Zmiana danych personalnych w systemie pocztowym (Exchange/O365). Wprowadzone wartości zastąpią aktualne dane po weryfikacji przez dział IT.</p>
            </div>
            {renderSlaNote()}
            <div className={s.twoCol}>
              <div className={s.field}>
                <label className={s.label}>Imię <span className={s.req}>*</span></label>
                <input type="text" value={personalData.firstName} onChange={(e) => setPersonalData({ ...personalData, firstName: e.target.value })} className={`${s.input} ${showErrors && formErrors.pdFirstName ? s.inputError : ""}`} />
                {fieldError("pdFirstName")}
              </div>
              <div className={s.field}>
                <label className={s.label}>Nazwisko <span className={s.req}>*</span></label>
                <input type="text" value={personalData.lastName} onChange={(e) => setPersonalData({ ...personalData, lastName: e.target.value })} className={`${s.input} ${showErrors && formErrors.pdLastName ? s.inputError : ""}`} />
                {fieldError("pdLastName")}
              </div>
            </div>
            <div className={s.twoCol}>
              <div className={s.field}>
                <label className={s.label}>Email <span className={s.req}>*</span></label>
                <input type="email" value={personalData.email} onChange={(e) => setPersonalData({ ...personalData, email: e.target.value })} className={`${s.input} ${showErrors && formErrors.pdEmail ? s.inputError : ""}`} />
                {fieldError("pdEmail")}
              </div>
              <div className={s.field}>
                <label className={s.label}>Telefon <span className={s.req}>*</span></label>
                <input type="text" value={personalData.phone} onChange={(e) => setPersonalData({ ...personalData, phone: e.target.value })} className={`${s.input} ${showErrors && formErrors.pdPhone ? s.inputError : ""}`} />
                {fieldError("pdPhone")}
              </div>
            </div>
            <div className={s.field}>
              <label className={s.label}>Stanowisko</label>
              <input type="text" value={personalData.companyPosition} onChange={(e) => setPersonalData({ ...personalData, companyPosition: e.target.value })} className={s.input} />
            </div>
            <div className={s.field}>
              <label className={s.label}>Powód zmiany <span className={s.req}>*</span></label>
              <textarea value={personalData.reason} onChange={(e) => setPersonalData({ ...personalData, reason: e.target.value })} className={`${s.textarea} ${showErrors && formErrors.pdReason ? s.inputError : ""}`} rows={3} placeholder="Opisz powód zmiany danych (min. 20 znaków)..." />
              {fieldError("pdReason")}
            </div>
          </div>
        );

      /* ──── SAP SUPPORT ──── */
      case TICKET_TYPE.SAP_SUPPORT:
        return (
          <div className={s.formSection}>
            <div className={s.infoBox}>
              <FiInfo className={s.infoBoxIcon} />
              {/* [G1] Adres celu z konfiguratora (kategoria TicketType=7), literał tylko jako fallback. */}
              <p>Zgłoszenie zostanie automatycznie wysłane do zespołu wsparcia SAP (<strong>{(sourceTileCategory || matchedCategory)?.forwardToEmail || "sap-krosno@euvic.support"}</strong>).{((sourceTileCategory || matchedCategory)?.forwardCcReporter ?? true) && " Kopia trafi na Twój adres e-mail."} Twoje dane kontaktowe z książki adresowej zostaną dołączone automatycznie.</p>
            </div>
            {renderSlaNote()}

            {/* Contact card – auto from O365 */}
            <div className={s.sapContactCard}>
              <div className={s.sapContactHeader}>
                <FiUserCheck size={14} />
                <span>Dane zgłaszającego (dołączone automatycznie)</span>
              </div>
              <div className={s.sapContactBody}>
                <div className={s.sapContactRow}>
                  <span className={s.sapContactLabel}>Imię i nazwisko</span>
                  <span className={s.sapContactValue}>{user ? `${user.firstName || ""} ${user.lastName || ""}`.trim() || "—" : "—"}</span>
                </div>
                <div className={s.sapContactRow}>
                  <span className={s.sapContactLabel}>Email</span>
                  <span className={s.sapContactValue}>{user?.email || "—"}</span>
                </div>
                <div className={s.sapContactRow}>
                  <span className={s.sapContactLabel}>Telefon</span>
                  <span className={s.sapContactValue}>{user?.phoneNumber || "—"}</span>
                </div>
              </div>
            </div>

            <div className={s.field}>
              <label className={s.label}>Temat zgłoszenia <span className={s.req}>*</span></label>
              <input
                type="text"
                value={sapData.subject}
                onChange={(e) => setSapData({ ...sapData, subject: e.target.value })}
                className={`${s.input} ${showErrors && formErrors.sapSubject ? s.inputError : ""}`}
                placeholder="Krótki opis problemu w SAP..."
              />
              {fieldError("sapSubject")}
            </div>
            <div className={s.field}>
              <label className={s.label}>Opis problemu <span className={s.req}>*</span></label>
              <textarea
                value={sapData.description}
                onChange={(e) => setSapData({ ...sapData, description: e.target.value })}
                className={`${s.textarea} ${showErrors && formErrors.sapDescription ? s.inputError : ""}`}
                rows={6}
                placeholder="Opisz szczegółowo problem, moduł SAP, komunikat błędu, kroki do odtworzenia (min. 20 znaków)..."
              />
              {fieldError("sapDescription")}
            </div>
            <div className={s.field}>
              <label className={s.label}>Priorytet</label>
              <select value={priority} onChange={(e) => setPriority(Number(e.target.value))} className={s.select}>
                <option value={TICKET_PRIORITY.LOW}>Niski</option>
                <option value={TICKET_PRIORITY.MEDIUM}>Średni</option>
                <option value={TICKET_PRIORITY.HIGH}>Wysoki</option>
              </select>
            </div>
            {renderDropZone()}
          </div>
        );

      default:
        return null;
    }
  };

  /* ═══════════════════════════════════════════════════════════
     MAIN RENDER
     ═══════════════════════════════════════════════════════════ */

  if (!isOpen) return null;

  const cardConfig = TYPE_CARDS.find((c) => c.type === selectedType);
  const FormIcon = selectedTileCategory
    ? (TILE_ICONS[selectedTileCategory.tileIcon] || DEFAULT_TILE_ICON)
    : (cardConfig?.icon || FiCpu);

  /* [2026-09-19] Jeden kafelek siatki. Wyciągnięte z JSX, bo po wprowadzeniu sekcji (nagłówki grup)
     kafelki renderują się z dwóch miejsc — a dwa osobne kształty kafelka to dwa miejsca, w których
     plakietka działu może zjechać z dołu okna i nikt tego nie zauważy.
     ⚠ KOLEJNOŚĆ ELEMENTÓW JEST TREŚCIĄ POLECENIA: ikona → nazwa → opis → PLAKIETKA NA KOŃCU
     („te badge maja byc na dole okna, to sa informacje malo istotne”). Dosunięcie do dolnej
     krawędzi robi `margin-top: auto` na `.cardDeptBadge` — kafelek jest kolumną flex. */
  const renderKafelekOkna = (cat, index) => {
    const systemType = SYSTEM_KIND_TO_TYPE[cat.tileFormKind];
    const TileIcon = TILE_ICONS[cat.tileIcon]
      || KIND_DEFAULT_ICON[cat.tileFormKind]
      || DEFAULT_TILE_ICON;
    const colorClass = COLOR_MAP[KIND_COLOR_CLASS[cat.tileFormKind] || "blue"] || "";
    /* Rozpiętość z reguły układu: 1 w pełnych rzędach, więcej w ostatnim, niepełnym rzędzie sekcji.
       `data-rozpietosc` jest tu po to, żeby dało się to ZMIERZYĆ — jsdom nie liczy siatki CSS,
       więc bez tego zapadka mogłaby najwyżej sprawdzić, czy w źródle stoi słowo „span”. */
    const rozpietosc = rozpietosciKafelkow.get(cat) || 1;
    return (
      <motion.button
        key={cat.id}
        type="button"
        className={`${s.card} ${colorClass} ${rozpietosc > 1 ? s.cardRozciagniety : ""}`}
        style={rozpietosc > 1 ? { gridColumn: `span ${rozpietosc}` } : undefined}
        data-rozpietosc={rozpietosc}
        onClick={() => (systemType != null ? selectType(systemType, cat) : selectTile(cat))}
        variants={cardVariants}
        custom={index + 1}
        initial="hidden"
        animate="visible"
        layout
        data-testid="kafelek-okna"
      >
        <div
          className={s.cardIconBox}
          style={cat.tileColor ? { color: cat.tileColor, background: `${cat.tileColor}1F` } : undefined}
        >
          <TileIcon />
        </div>
        <span className={s.cardLabel}>{cat.name}</span>
        <span className={s.cardHint}>{cat.tileDescription || "Utwórz zgłoszenie w tej kategorii."}</span>
        {cat.handlingDepartment?.name && (
          <span className={s.cardDeptBadge}>
            <FiBriefcase size={11} /> {cat.handlingDepartment.name}
          </span>
        )}
      </motion.button>
    );
  };

  return (
    <Modal onClose={zamknijOkno} isOpen title="Utwórz nowe zgłoszenie" width="68vw" height="85vh">
      <div className={s.shell}>
        {/* [polecenie właściciela 2026-09-28] Karty okna. Przy ukrytym module wniosków pasek znika, a okno wygląda
            dokładnie jak przed tą zmianą (jedna karta to przełącznik, który nic nie przełącza). */}
        {wnioskiDostepne && (
          <div
            className={s.kartyOkna}
            role="tablist"
            aria-label="Rodzaj sprawy"
            onKeyDown={klawiszKart}
            data-testid="karty-nowego-zgloszenia"
          >
            {KARTY_OKNA.map(({ klucz, etykieta, Ikona }) => {
              const aktywna = kartaAktywna === klucz;
              return (
                <button
                  key={klucz}
                  ref={(el) => { przyciskiKartRef.current[klucz] = el; }}
                  type="button"
                  role="tab"
                  id={`${idKart}-karta-${klucz}`}
                  aria-selected={aktywna}
                  /* Panel wniosków montuje się leniwie — odniesienie ARIA dopiero, gdy element istnieje w DOM. */
                  aria-controls={klucz === KARTA.wnioski && !kartaWnioskowZamontowana ? undefined : `${idKart}-panel-${klucz}`}
                  tabIndex={aktywna ? 0 : -1}
                  className={`${s.kartaOkna} ${aktywna ? s.kartaOknaAktywna : ""}`}
                  onClick={() => wybierzKarte(klucz)}
                  data-karta={klucz}
                >
                  <Ikona size={14} aria-hidden="true" />
                  {etykieta}
                </button>
              );
            })}
          </div>
        )}
        <div
          className={s.panelKarty}
          role={wnioskiDostepne ? "tabpanel" : undefined}
          id={`${idKart}-panel-${KARTA.techniczne}`}
          aria-labelledby={wnioskiDostepne ? `${idKart}-karta-${KARTA.techniczne}` : undefined}
          hidden={kartaAktywna !== KARTA.techniczne}
          data-testid="panel-spraw-technicznych"
        >
        <AnimatePresence mode="wait" custom={direction}>
          {step === STEP.SELECT ? (
            /* ═══════ STEP 0: TYPE SELECTION ═══════ */
            <motion.div
              key="select"
              className={s.selectionView}
              variants={stepVariants}
              custom={direction}
              initial="enter"
              animate="center"
              exit="exit"
            >
              <div className={s.heading}>
                <h3 className={s.title}>Jak możemy Ci pomóc?</h3>
                <p className={s.subtitle}>Wybierz kategorię zgłoszenia, która najlepiej opisuje Twój problem</p>
              </div>

              {/* [polecenie właściciela 2026-09-19] Wyszukiwarka okien. Szuka po nazwie okna, opisie
                  kafelka, nazwach kategorii pod oknem I po frazach słownika reguł — dlatego „nie drukuje"
                  prowadzi do okna drukarek, choć tych słów nie ma nigdzie na ekranie. */}
              {dataDrivenTiles.length > 0 && (
                <div className={s.szukajkaOkien}>
                  <FiSearch className={s.szukajkaIkona} size={14} aria-hidden="true" />
                  <input
                    type="search"
                    className={s.szukajkaPole}
                    value={frazaSzukania}
                    onChange={(e) => setFrazaSzukania(e.target.value)}
                    placeholder="Szukaj okna zgłoszenia — np. „nie drukuje”, „dostęp do dysku”, „urlop”"
                    aria-label="Szukaj okna zgłoszenia"
                    data-testid="szukajka-okien"
                  />
                  {!!frazaSzukania && (
                    <button
                      type="button"
                      className={s.szukajkaCzysc}
                      onClick={() => setFrazaSzukania("")}
                      aria-label="Wyczyść frazę wyszukiwania"
                    >
                      <FiX size={13} />
                    </button>
                  )}
                </div>
              )}

              {/* Filtr okien per moduł (polecenie właściciela 2026-09-12). Domyślnie zawężony do
                  modułu, z którego człowiek wszedł; „Wszystkie" pokazuje komplet.
                  [2026-09-19] Lista chipów pochodzi ze słownika modułów w bazie — nie z kodu. */}
              {pokazFiltrModulow && (
                <div className={s.moduleFilter} role="group" aria-label="Filtr modułu zgłoszenia" data-testid="filtr-modulow">
                  <button
                    type="button"
                    className={`${s.moduleChip} ${!filtrSkuteczny ? s.moduleChipActive : ""}`}
                    aria-pressed={!filtrSkuteczny}
                    onClick={() => setFiltrModulu("")}
                  >
                    Wszystkie
                  </button>
                  {modulyOkienPelne.map(({ kod, nazwa }) => (
                    <button
                      key={kod}
                      type="button"
                      className={`${s.moduleChip} ${filtrSkuteczny === kod ? s.moduleChipActive : ""}`}
                      aria-pressed={filtrSkuteczny === kod}
                      onClick={() => setFiltrModulu(kod)}
                    >
                      {nazwa || nazwaModulu(kod)}
                    </button>
                  ))}
                </div>
              )}

              {/* [polecenie właściciela 2026-09-20] Liczba kolumn jest WYLICZANA z liczby widocznych
                  kafelków (reguła w `ukladSiatkiOkien.js`) i wjeżdża do arkusza zmienną CSS, a nie
                  klasą na każdą możliwą liczbę. Zawężenie na wąskim ekranie robi `@media` w arkuszu:
                  ustawia `grid-template-columns` WPROST, więc wygrywa z tą zmienną. */}
              <div
                className={s.grid}
                style={{ "--kolumny-siatki": kolumnySiatki }}
                data-kolumny={kolumnySiatki}
                data-testid="siatka-okien"
              >
                {/* [2026-07-27] Zero okien wbudowanych na sztywno — administrator buduje siatkę
                    w konfiguratorze; pusta konfiguracja = czytelny pusty stan zamiast martwych kart. */}
                {dataDrivenTiles.length === 0 && (() => {
                  // [N3 2026-08-31] Trzy różne sytuacje — trzy różne komunikaty. Wcześniej wszystkie
                  // trzy wyglądały identycznie („Brak skonfigurowanych okien zgłoszeń"), więc nikt
                  // nie wiedział, czy okien nie ma, czy są, ale odfiltrowane.
                  const ukryte = (tilesDiagnostic?.tiles || []).filter((t) => !t.visible);
                  const naprawde = !tilesDiagnostic || tilesDiagnostic.totalTiles === 0;
                  const powody = [...new Set(ukryte.map((t) => t.reason).filter(Boolean))];
                  return (
                    <div className={s.emptyTilesState}>
                      <FiInbox size={26} />
                      {naprawde ? (
                        <>
                          <b>Brak skonfigurowanych okien zgłoszeń</b>
                          <p>Administrator nie dodał jeszcze żadnego okna w konfiguratorze zgłoszeń.
                          Skontaktuj się z działem IT, jeśli potrzebujesz zgłosić sprawę.</p>
                        </>
                      ) : (
                        <>
                          <b>Okna zgłoszeń istnieją, ale żadne nie jest dla Ciebie dostępne</b>
                          <p>
                            W konfiguracji jest {tilesDiagnostic.totalTiles} okien, a Ty nie widzisz żadnego.
                            Powód{powody.length > 1 ? "y" : ""}:
                          </p>
                          <ul className={s.emptyTilesReasons}>
                            {powody.map((r) => <li key={r}>{r}</li>)}
                          </ul>
                          {ukryte.some((t) => (t.allowedDepartments || []).length > 0) && (
                            <p>
                              Tworzyć w tych modułach mogą działy:{" "}
                              {[...new Set(ukryte.flatMap((t) => t.allowedDepartments || []))].join(", ")}.
                            </p>
                          )}
                          <p>Poproś administratora o dopisanie Twojego działu albo o włączenie okna.</p>
                        </>
                      )}
                    </div>
                  );
                })()}

                {/* [polecenie właściciela 2026-09-19] Pusty wynik SZUKANIA to nie to samo co brak okien
                    w konfiguracji (blok N3 wyżej): tam wyjściem jest administrator, tu — wyczyszczenie
                    frazy. Jeden komunikat na dwie sytuacje wysyłałby ludzi do IT po nic. */}
                {pustyWynikSzukania && (
                  <div className={`${s.emptyTilesState} ${s.pustyWynikSzukania}`} data-testid="pusty-wynik-szukania">
                    <FiSearch size={26} />
                    <b>Żadne okno nie pasuje do wyszukiwania</b>
                    <p>
                      {frazaSzukania.trim()
                        ? <>Nie znaleźliśmy okna dla frazy „{frazaSzukania.trim()}”{filtrSkuteczny ? ` w module „${nazwaModulu(filtrSkuteczny)}”` : ""}. Spróbuj krótszego słowa albo pokaż wszystkie moduły.</>
                        : <>Moduł „{nazwaModulu(filtrSkuteczny)}” nie ma w tej chwili żadnego okna dostępnego dla Ciebie.</>}
                    </p>
                    {szukaniemLubFiltrem && (
                      <button
                        type="button"
                        className={s.pustyWynikReset}
                        onClick={() => { setFrazaSzukania(""); setFiltrModulu(""); }}
                      >
                        Wyczyść wyszukiwanie
                      </button>
                    )}
                  </div>
                )}

                {/* [G5] PELNY data-driven render: JEDNA siatka kafelkow z kategorii —
                    systemowe (drives/buyout/requisition-it/personal/sap) i dzialowe
                    (generic/requisition), z ikona/kolorem/kolejnoscia z konfiguratora.
                    [2026-09-19] Grupy (`isGroup`) są NAGŁÓWKAMI sekcji wewnątrz tej samej siatki
                    (nagłówek zajmuje cały wiersz), a nie osobnymi kafelkami. */}
                {useDataDrivenGrid ? sekcjeKafelkow.map((sekcja) => (
                  <React.Fragment key={sekcja.id || "__bez-grupy"}>
                    {sekcja.nazwa && (
                      <h4 className={s.sekcjaNaglowek} data-testid="naglowek-sekcji">{sekcja.nazwa}</h4>
                    )}
                    {sekcja.okna.map((cat) => renderKafelekOkna(cat, widoczneKafelki.indexOf(cat)))}
                  </React.Fragment>
                )) : (
                  <>
                    {/* Fallback legacy (stary backend bez kafelkow systemowych): karty wbudowane + dynamiczne. */}
                    {visibleTypeCards.filter((c) => c.type !== TICKET_TYPE.TECHNICAL).map(({ type, icon: Icon, title, desc, color }, index) => (
                      <motion.button
                        key={type}
                        type="button"
                        className={`${s.card} ${COLOR_MAP[color] || ""}`}
                        onClick={() => selectType(type)}
                        variants={cardVariants}
                        custom={index + 1}
                        initial="hidden"
                        animate="visible"
                      >
                        <div className={s.cardIconBox}><Icon /></div>
                        <span className={s.cardLabel}>{title}</span>
                        <span className={s.cardHint}>{desc}</span>
                        {handlingDeptByType[type] && (
                          <span className={s.cardDeptBadge}>
                            <FiBriefcase size={11} /> {handlingDeptByType[type]}
                          </span>
                        )}
                      </motion.button>
                    ))}
                    {dynamicTiles.map((cat, index) => {
                      const TileIcon = TILE_ICONS[cat.tileIcon] || DEFAULT_TILE_ICON;
                      return (
                        <motion.button
                          key={cat.id}
                          type="button"
                          className={`${s.card} ${COLOR_MAP.blue || ""}`}
                          onClick={() => selectTile(cat)}
                          variants={cardVariants}
                          custom={TYPE_CARDS.length + index}
                          initial="hidden"
                          animate="visible"
                        >
                          <div className={s.cardIconBox}><TileIcon /></div>
                          <span className={s.cardLabel}>{cat.name}</span>
                          <span className={s.cardHint}>{cat.tileDescription || "Utwórz zgłoszenie w tej kategorii."}</span>
                          {cat.handlingDepartment?.name && (
                            <span className={s.cardDeptBadge}>
                              <FiBriefcase size={11} /> {cat.handlingDepartment.name}
                            </span>
                          )}
                        </motion.button>
                      );
                    })}
                  </>
                )}
              </div>
            </motion.div>
          ) : (
            /* ═══════ STEP 1: FORM ═══════ */
            <motion.div
              key="form"
              className={s.formStepWrapper}
              variants={stepVariants}
              custom={direction}
              initial="enter"
              animate="center"
              exit="exit"
            >
              <form onSubmit={handleSubmit} className={s.formView}>
                {/* [POLECENIE WLASCICIELA 2026-09-12] Pasek przywrocenia szkicu.
                    Mowi WPROST o zalacznikach: obiektow plikow wybranych w okienku systemowym nie da
                    sie odtworzyc, a milczenie o tym pozwolilo by wyslac zgloszenie bez skanu.
                    „Zacznij od nowa” jest OBOK, bo czasem czlowiek wraca do innej sprawy. */}
                {szkicPrzywrocony && (
                  <div className={s.szkicPasek} role="status">
                    <FiRotateCcw size={14} aria-hidden="true" />
                    <span>
                      Przywrócono rozpoczęte zgłoszenie. <strong>Załączniki trzeba wskazać ponownie</strong> —
                      pliki nie przeżywają zamknięcia okna.
                    </span>
                    <button
                      type="button"
                      className={s.szkicOdrzuc}
                      onClick={() => { wyczyscSzkic(user?.id); resetForm(); }}
                    >
                      Zacznij od nowa
                    </button>
                  </div>
                )}

                {/* ─── Header ─── */}
                <div className={s.formHeader}>
                  <button type="button" onClick={goBack} className={s.backPill}>
                    <FiArrowLeft size={14} /> Wróć
                  </button>
                  <div className={s.headerInfo}>
                    <div className={`${s.headerIcon} ${HEADER_ICON_MAP[cardConfig?.color] || ""}`}>
                      <FormIcon />
                    </div>
                    <h4 className={s.headerTitle}>
                      {selectedTileCategory ? selectedTileCategory.name : TICKET_TYPE_LABELS[selectedType]}
                    </h4>
                  </div>
                  {renderSlaStrip()}
                </div>

                {/* ─── Scrollable body ─── */}
                <div className={s.formBody}>
                  {renderFormBody()}
                  {/* [G5] Pola własne z konfiguratora na formularzach SYSTEMOWYCH (dla
                      dynamicznych kafelków renderuje je renderTileFormBody). */}
                  {!selectedTileCategory && sourceTileCategory && (
                    <div className={s.formSection}>{renderRoutingInfo()}{tileFieldDefs.length > 0 && renderTileCustomFields()}</div>
                  )}
                </div>

                {/* ─── Footer ─── */}
                <div className={s.formFooter}>
                  <button type="button" onClick={zamknijOkno} className={s.btnCancel}>Anuluj</button>
                  <button type="submit" className={s.btnSubmit} disabled={loading || (showErrors && !isFormValid)}>
                    <FiSend size={15} />
                    {loading ? "Wysyłanie..." : selectedType === TICKET_TYPE.DRIVE_ACCESS ? "Wyślij wniosek" : "Utwórz zgłoszenie"}
                  </button>
                </div>
              </form>
            </motion.div>
          )}
        </AnimatePresence>
        </div>
        {wnioskiDostepne && kartaWnioskowZamontowana && (
          <div
            className={s.panelKarty}
            role="tabpanel"
            id={`${idKart}-panel-${KARTA.wnioski}`}
            aria-labelledby={`${idKart}-karta-${KARTA.wnioski}`}
            hidden={kartaAktywna !== KARTA.wnioski}
            data-testid="panel-wnioskow-pracowniczych"
          >
            <KartaWnioskowPracowniczych
              onZamknij={zamknijOkno}
              onWypelnienie={ustawWypelnienieWniosku}
              potwierdzPorzucenie={potwierdzPorzucenieWniosku}
              onDoSprawTechnicznych={doSprawTechnicznych}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default MyNewTicketModal;
